/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  APIError,
  AWSExternalId,
  AWSTemplateUrlRequest,
  AWSTemplateUrlResponse,
  AccessReview,
  AccessReviewAccount,
  AccessReviewAccountForTenantMember,
  AccessReviewVendor,
  ActivityList,
  AddFeatureFlagRequest,
  AgentDeviceDataResponse,
  AgentDeviceStatusResponse,
  AgentDeviceUpdateRequest,
  AppleMDMCommandRequest,
  AppleMDMGenCSRRequest,
  AppleMDMSettings,
  AssetTypeList,
  AssignTesterRequest,
  AttackSurfaceAsset,
  AttackSurfaceScanInfo,
  AttackSurfaceTarget,
  Audit,
  AuditLogList,
  AuditType,
  Auth0RevokeSessionsRequest,
  Auth0UserInfoResponse,
  BulkUpdateCodeHealthIssueBody,
  CheckList,
  ChecklistTemplate,
  ChecklistTemplateItem,
  ChecklistTemplateList,
  CloseByAcceptedRequest,
  CodeHealthIgnoreRule,
  CodeHealthIssue,
  CodeHealthIssueType,
  CodeHealthOverview,
  CodeSecurityFindingList,
  CodeSecurityIgnoreRule,
  CodeSecurityIgnoreRuleList,
  CodeSecurityScanInfoList,
  CodeSecurityScanUploadRequest,
  CodeSecuritySettings,
  ComplianceFramework,
  ComplianceFrameworkList,
  ComplianceRequirementList,
  Connection,
  Control,
  ControlList,
  ControlTypeList,
  ControlUpdateAssignedMemberRequest,
  ControlUpdateAssignedReviewerRequest,
  CreateAccessReviewAccountRequest,
  CreateAccessReviewRequest,
  CreateAuditPayload,
  CreateChecklistTemplateItemRequest,
  CreateChecklistTemplateRequest,
  CreateCodeHealthIgnoreRuleBody,
  CreateCodeSecurityIgnoreRuleBody,
  CreateConnectionRequest,
  CreateControlRequest,
  CreateDomainRequest,
  CreateEngagementRequest,
  CreateEvidenceRequest,
  CreateEvidenceRequestRequest,
  CreateFindingRequest,
  CreateGroupRequest,
  CreateImageResponse,
  CreateInAppDocumentRequest,
  CreateIngressHostnameRequest,
  CreateIntegrationRequest,
  CreateMemberChecklistItemRequest,
  CreateMemberChecklistRequest,
  CreatePolicyRequest,
  CreateReportRequest,
  CreateRiskAssessmentRequest,
  CreateRiskRequest,
  CreateTenantComplianceFrameworkRequest,
  CreateTenantInviteRequest,
  CreateTenantRequest,
  CreateTesterInviteRequest,
  CreateUpdateTenantVendor,
  DeviceLoginRequest,
  DeviceLoginResponse,
  Domain,
  DomainList,
  Engagement,
  EngagementList,
  Evidence,
  EvidenceRequest,
  Exception,
  ExceptionList,
  ExposedAccount,
  ExposedAccountUpdateRequest,
  ExternalAccount,
  ExternalAccountList,
  ExternalAccountUpdateRequest,
  FeatureFlag,
  FeatureFlagList,
  Finding,
  FindingList,
  FindingSource,
  GitRepository,
  GitRepositoryBranchList,
  GitRepositoryCreate,
  GitRepositoryList,
  GitRepositoryProvider,
  GitRepositoryUpdate,
  Group,
  HModuleLanding,
  IgnoreAssetGlobally,
  InAppDocument,
  InAppDocumentList,
  InAppDocumentTemplate,
  InAppDocumentTemplateList,
  Integration,
  IntegrationInspectorRequest,
  IntegrationInspectorResponse,
  IntegrationList,
  IntegrationType,
  IntegrationTypeList,
  LinkEvidenceRequest,
  LinkEvidenceToVendorRequest,
  MemberChecklist,
  MemberChecklistItem,
  MemberChecklists,
  Meta,
  Monitor,
  MonitorList,
  MonitorRunList,
  MonitorStateList,
  MonitorTypeList,
  MonitorUpdateConfig,
  MonitorUpdateEnabled,
  MonitorUpdateIgnoreStatusForAssets,
  MyProgressSecurityTrainingModule,
  MyProgressUpdateSectionProgressRequestBody,
  NangoAuthCallbackRequest,
  NangoAuthSessionTokenResponse,
  Policy,
  PolicyList,
  PolicySignature,
  PolicySignatureList,
  PolicyTemplate,
  PolicyTemplateList,
  PolicyTypeList,
  PolicyVersion,
  PolicyVersionList,
  PortalTask,
  PreEnrollAgentDeviceRequest,
  PreEnrollAgentDeviceResponse,
  PreSetupConnectionResponse,
  PublishPolicyVersionRequest,
  QuestionnaireDetail,
  QuestionnaireList,
  QuestionnaireQuestion,
  ReconnectConnectionRequest,
  RemindMembersTasksRequest,
  Report,
  ReportDownloadResponse,
  ReportList,
  ReportVersionList,
  RequestRemediationRequest,
  ResultSnapshotList,
  Risk,
  RiskAssessment,
  ScanInfoList,
  ScanResultList,
  SecurityTrainingModule,
  SharedData,
  SlackChannelList,
  SlackSettings,
  SubdomainList,
  SubmitControlReviewRequests,
  Task,
  TaskList,
  Tenant,
  TenantComplianceFramework,
  TenantComplianceFrameworkList,
  TenantComplianceProgramData,
  TenantComplianceRequirement,
  TenantComplianceRequirementList,
  TenantDashboard,
  TenantDevice,
  TenantDeviceList,
  TenantEmployeeCreateRequest,
  TenantHModuleMeta,
  TenantInvite,
  TenantInviteList,
  TenantList,
  TenantMember,
  TenantMemberApplicablePolicy,
  TenantMemberList,
  TenantSettings,
  TenantTester,
  TenantVendor,
  TenantVendorDiscoveryDeletedCount,
  TenantVendorDiscoveryList,
  TenantVendorDiscoveryWorkflowRun,
  TenantVendorList,
  TenantVendorWithReviewer,
  TesterInvite,
  TesterInviteList,
  TrustDocument,
  TrustDocumentCreateRequest,
  TrustDocumentRequest,
  TrustDocumentRequestUpdate,
  TrustDocumentResponse,
  TrustPageConfigsResponse,
  TrustPageConfigsUpdate,
  TrustPageFaviconUpdateRequest,
  TrustPageGetResponse,
  TrustPageLogoUpdateRequest,
  TrustSecurityIssueRequest,
  TrustSecurityIssueRequestUpdate,
  TrustSecurityIssueResponse,
  UnassignTesterRequest,
  UnenrollAppleMDMDeviceRequest,
  UnlinkEvidenceFromVendorRequest,
  UnlinkEvidenceRequest,
  UpdateAccessReviewAccountRequest,
  UpdateAccessReviewRequest,
  UpdateAccessReviewVendorRequest,
  UpdateAssetRequest,
  UpdateAttackSurfaceAssetRequest,
  UpdateAuditObservationPeriodPayload,
  UpdateAuditStagePayload,
  UpdateChecklistTemplateItemRequest,
  UpdateCodeHealthIgnoreRuleBody,
  UpdateCodeHealthIssueBody,
  UpdateCodeHealthIssueTypeBody,
  UpdateCodeSecurityFindingBody,
  UpdateCodeSecurityIgnoreRuleBody,
  UpdateCodeSecuritySettingsRequest,
  UpdateConnectionConfigurationRequest,
  UpdateControlCommentRequest,
  UpdateControlContentRequest,
  UpdateEngagementRequest,
  UpdateEvidenceRequest,
  UpdateEvidenceRequestRequest,
  UpdateExceptionNotes,
  UpdateExceptionVisibility,
  UpdateFindingRequest,
  UpdateGroupRequest,
  UpdateInAppDocumentRequest,
  UpdateIntegrationRequest,
  UpdateMemberChecklistItemRequest,
  UpdateMemberChecklistRequest,
  UpdatePolicyRequest,
  UpdatePolicyVersionRequest,
  UpdateQuestionnaireBody,
  UpdateQuestionnaireOwnerBody,
  UpdateQuestionnaireQuestionAnswerBody,
  UpdateReportRequest,
  UpdateRiskAssessmentRequest,
  UpdateRiskRequest,
  UpdateScanFindingState,
  UpdateSecurityTrainingModuleRequestBody,
  UpdateSlackSettingsRequest,
  UpdateTenantComplianceFrameworkRequest,
  UpdateTenantDeviceRequest,
  UpdateTenantMemberRequest,
  UpdateTenantRequest,
  UpdateTenantSettingsRequest,
  UploadAuditReportPayload,
  UploadNewQuestionnaireBody,
  UploadVendorLogoRequest,
  UpsertAppleMDMDeviceRequest,
  UpsertVendor,
  User,
  UserList,
  UserLogin,
  UserRegister,
  UserSecurityTrainingProgress,
  Vendor,
  VendorList,
  WorkflowList,
  WorkflowType,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Check server live status
   *
   * @tags Health
   * @name HealthGetLivez
   * @summary Check server liveness
   * @request GET:/api/v1/livez
   */
  healthGetLivez = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/api/v1/livez`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Check server ready status
   *
   * @tags Health
   * @name HealthGetReadyz
   * @summary Check server readiness
   * @request GET:/api/v1/readyz
   */
  healthGetReadyz = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/api/v1/readyz`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Gets the server metadata
   *
   * @tags Meta
   * @name MetaGet
   * @summary Get server metadata
   * @request GET:/api/v1/meta
   */
  metaGet = (params: RequestParams = {}) =>
    this.request<Meta, any>({
      path: `/api/v1/meta`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Proxies sentry requests from frontend
   *
   * @tags Sentry
   * @name SentryCreate
   * @summary Proxies sentry requests from frontend
   * @request POST:/api/v1/sentry
   * @secure
   */
  sentryCreate = (data: string, params: RequestParams = {}) =>
    this.request<MonitorUpdateConfig, APIError>({
      path: `/api/v1/sentry`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Text,
      format: "json",
      ...params,
    });
  /**
   * @description Logs in a user. This endpoint is only enabled in dev and preview environments.
   *
   * @tags User
   * @name UserUpdateLogin
   * @summary Login user
   * @request POST:/api/v1/users/login
   */
  userUpdateLogin = (data: UserLogin, params: RequestParams = {}) =>
    this.request<User, APIError>({
      path: `/api/v1/users/login`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Gets the login page
   *
   * @tags User
   * @name UserGetLogin
   * @summary Get login page
   * @request GET:/api/v1/users/login/{app}
   */
  userGetLogin = (app: "app" | "portal" | "admin" | "tester", params: RequestParams = {}) =>
    this.request<any, void>({
      path: `/api/v1/users/login/${app}`,
      method: "GET",
      ...params,
    });
  /**
   * @description Registers a new user. This endpoint is only enabled in dev and preview environments.
   *
   * @tags User
   * @name UserCreateRegister
   * @summary Register user
   * @request POST:/api/v1/users/register
   */
  userCreateRegister = (data: UserRegister, params: RequestParams = {}) =>
    this.request<User, APIError>({
      path: `/api/v1/users/register`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Logs out the current user
   *
   * @tags User
   * @name UserGetLogout
   * @summary Logout user
   * @request GET:/api/v1/users/logout/{app}
   * @secure
   */
  userGetLogout = (app: "app" | "portal" | "admin" | "tester", params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/v1/users/logout/${app}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Handles the callback for Auth0
   *
   * @tags User
   * @name UserGetAuth0Callback
   * @summary Get Auth0 callback page
   * @request GET:/api/v1/users/auth/auth0/callback/{app}
   */
  userGetAuth0Callback = (app: "app" | "portal" | "admin" | "tester", params: RequestParams = {}) =>
    this.request<any, void | APIError>({
      path: `/api/v1/users/auth/auth0/callback/${app}`,
      method: "GET",
      ...params,
    });
  /**
   * @description Gets the current user
   *
   * @tags User
   * @name UserGetCurrent
   * @summary Get current user
   * @request GET:/api/v1/users/current
   * @secure
   */
  userGetCurrent = (params: RequestParams = {}) =>
    this.request<User, APIError>({
      path: `/api/v1/users/current`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Send a validation email to the user
   *
   * @name UserUpdateSendVerifyEmail
   * @summary Send validation email
   * @request PATCH:/api/v1/users/current
   * @secure
   */
  userUpdateSendVerifyEmail = (params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/users/current`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * @description Gets a list of tenant invites for the user.
   *
   * @tags User
   * @name UserGetInvites
   * @summary Get tenant invites
   * @request GET:/api/v1/users/current/invites
   * @secure
   */
  userGetInvites = (params: RequestParams = {}) =>
    this.request<TenantInviteList, APIError>({
      path: `/api/v1/users/current/invites`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a user by their ID
   *
   * @tags User
   * @name UserGetId
   * @summary Get user by ID
   * @request GET:/api/v1/users/{user}
   * @secure
   */
  userGetId = (user: string, params: RequestParams = {}) =>
    this.request<User, APIError>({
      path: `/api/v1/users/${user}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get exposed accounts for user
   *
   * @tags Exposed Account
   * @name UserGetExposedAccounts
   * @summary Get exposed accounts for user
   * @request GET:/api/v1/users/current/exposed-accounts
   * @secure
   */
  userGetExposedAccounts = (params: RequestParams = {}) =>
    this.request<ExposedAccount[], APIError>({
      path: `/api/v1/users/current/exposed-accounts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a list of tenant memberships for the user.
   *
   * @tags User
   * @name MembershipList
   * @summary Get tenant memberships
   * @request GET:/api/v1/users/current/memberships
   * @secure
   */
  membershipList = (params: RequestParams = {}) =>
    this.request<TenantMemberList, APIError>({
      path: `/api/v1/users/current/memberships`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets the list of superadmins
   *
   * @tags User
   * @name UserGetSuperadmins
   * @summary Get list of superadmins
   * @request GET:/api/v1/users/current/superadmins
   * @secure
   */
  userGetSuperadmins = (params: RequestParams = {}) =>
    this.request<User[], APIError>({
      path: `/api/v1/users/current/superadmins`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new tenant
   *
   * @tags Tenant
   * @name TenantCreate
   * @summary Create tenant
   * @request POST:/api/v1/tenants
   * @secure
   */
  tenantCreate = (data: CreateTenantRequest, params: RequestParams = {}) =>
    this.request<Tenant, APIError>({
      path: `/api/v1/tenants`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all tenants (superadmin endpoint)
   *
   * @tags Tenant
   * @name AdminListTenants
   * @summary Get tenant
   * @request GET:/api/v1/tenants
   * @secure
   */
  adminListTenants = (params: RequestParams = {}) =>
    this.request<TenantList, APIError>({
      path: `/api/v1/tenants`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a tenant by id.
   *
   * @tags Tenant
   * @name TenantGet
   * @summary Get tenant
   * @request GET:/api/v1/tenants/{tenant}
   * @secure
   */
  tenantGet = (tenant: string, params: RequestParams = {}) =>
    this.request<Tenant, APIError>({
      path: `/api/v1/tenants/${tenant}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates tenants for the current user
   *
   * @tags Tenant
   * @name TenantUpdate
   * @summary Get tenant
   * @request POST:/api/v1/tenants/{tenant}
   * @secure
   */
  tenantUpdate = (tenant: string, data: UpdateTenantRequest, params: RequestParams = {}) =>
    this.request<Tenant, APIError>({
      path: `/api/v1/tenants/${tenant}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a tenant by id.
   *
   * @tags Tenant
   * @name TenantDelete
   * @summary Get tenant
   * @request DELETE:/api/v1/tenants/{tenant}
   * @secure
   */
  tenantDelete = (tenant: string, params: RequestParams = {}) =>
    this.request<Tenant, APIError>({
      path: `/api/v1/tenants/${tenant}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List a tenant's members
   *
   * @tags TenantMember
   * @name TenantMemberList
   * @summary List the members of a tenant
   * @request GET:/api/v1/tenants/{tenant}/members
   * @secure
   */
  tenantMemberList = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantMemberList, APIError>({
      path: `/api/v1/tenants/${tenant}/members`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Remind multiple tenant members to complete tasks
   *
   * @tags Tenant
   * @name TenantUpdateRemindMembersTasks
   * @summary Remind multiple tenant members to complete tasks
   * @request POST:/api/v1/tenants/{tenant}/remind-members/tasks
   * @secure
   */
  tenantUpdateRemindMembersTasks = (tenant: string, data: RemindMembersTasksRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${tenant}/remind-members/tasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Update a tenant member by id.
   *
   * @name TenantMemberUpdate
   * @summary Update tenant member
   * @request PATCH:/api/v1/tenant-members/{tenant-member}
   * @secure
   */
  tenantMemberUpdate = (tenantMember: string, data: UpdateTenantMemberRequest, params: RequestParams = {}) =>
    this.request<TenantMember, APIError>({
      path: `/api/v1/tenant-members/${tenantMember}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a tenant member by id.
   *
   * @name TenantMemberDelete
   * @summary Delete tenant member
   * @request DELETE:/api/v1/tenant-members/{tenant-member}
   * @secure
   */
  tenantMemberDelete = (tenantMember: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenant-members/${tenantMember}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Remind a tenant member to complete tasks
   *
   * @name TenantMemberUpdateRemindTasks
   * @summary Remind a tenant member to complete tasks
   * @request POST:/api/v1/tenant-members/{tenant-member}/remind/tasks
   * @secure
   */
  tenantMemberUpdateRemindTasks = (
    tenantMember: string,
    data: {
      /** The tasks to remind the user to complete in the Oneleet Portal */
      portalTasks: PortalTask[];
    },
    params: RequestParams = {},
  ) =>
    this.request<TenantMember, APIError>({
      path: `/api/v1/tenant-members/${tenantMember}/remind/tasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remind a tenant member to complete actions on their device
   *
   * @name TenantMemberUpdateRemindDevice
   * @summary Remind a tenant member to complete actions on their device
   * @request POST:/api/v1/tenant-members/{tenant-member}/remind/device
   * @secure
   */
  tenantMemberUpdateRemindDevice = (
    tenantMember: string,
    data: {
      /** The name of the device */
      device: string;
      /** The actions to remind the user to complete */
      actions: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/tenant-members/${tenantMember}/remind/device`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Resets the MFA for a user
   *
   * @name TenantMemberUpdateResetMfa
   * @summary Reset MFA
   * @request POST:/api/v1/tenant-members/{tenant-member}/reset-mfa
   * @secure
   */
  tenantMemberUpdateResetMfa = (tenantMember: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenant-members/${tenantMember}/reset-mfa`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Gets the dashboard for the current tenant
   *
   * @tags Tenant
   * @name TenantGetDashboard
   * @summary Get tenant dashboard
   * @request GET:/api/v1/tenants/{tenant}/dashboard
   * @secure
   */
  tenantGetDashboard = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantDashboard, APIError>({
      path: `/api/v1/tenants/${tenant}/dashboard`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets the trust page for the current tenant
   *
   * @tags Tenant
   * @name TenantGetTrust
   * @summary Get tenant trust page
   * @request GET:/api/v1/tenants/{slug}/trust
   */
  tenantGetTrust = (slug: string, params: RequestParams = {}) =>
    this.request<TrustPageGetResponse, APIError>({
      path: `/api/v1/tenants/${slug}/trust`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get the trust page configs for the current tenant, such as publish or un-publish status
   *
   * @tags Tenant
   * @name TenantGetTrustConfigs
   * @summary Get tenant trust page configs
   * @request GET:/api/v1/tenants/{tenant}/trust/config
   * @secure
   */
  tenantGetTrustConfigs = (tenant: string, params: RequestParams = {}) =>
    this.request<TrustPageConfigsResponse, APIError>({
      path: `/api/v1/tenants/${tenant}/trust/config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the trust page configs for the current tenant, such as publish or un-publish
   *
   * @tags Tenant
   * @name TenantUpdateTrustConfigs
   * @summary Update tenant trust page configs
   * @request PATCH:/api/v1/tenants/{tenant}/trust/config
   * @secure
   */
  tenantUpdateTrustConfigs = (tenant: string, data: TrustPageConfigsUpdate, params: RequestParams = {}) =>
    this.request<TrustPageConfigsResponse, APIError>({
      path: `/api/v1/tenants/${tenant}/trust/config`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Upload a logo for the trust page
   *
   * @name TenantUpdateTrustPageLogo
   * @summary Upload a logo for the trust page
   * @request POST:/api/v1/tenants/{tenant}/trust/config/logo
   * @secure
   */
  tenantUpdateTrustPageLogo = (tenant: string, data: TrustPageLogoUpdateRequest, params: RequestParams = {}) =>
    this.request<string, APIError>({
      path: `/api/v1/tenants/${tenant}/trust/config/logo`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Upload a favicon for the trust page
   *
   * @name TenantUpdateTrustPageFavicon
   * @summary Upload a favicon for the trust page
   * @request POST:/api/v1/tenants/{tenant}/trust/config/favicon
   * @secure
   */
  tenantUpdateTrustPageFavicon = (tenant: string, data: TrustPageFaviconUpdateRequest, params: RequestParams = {}) =>
    this.request<string, APIError>({
      path: `/api/v1/tenants/${tenant}/trust/config/favicon`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Refresh the trust page ingress checks for the current tenant
   *
   * @tags Tenant
   * @name TenantUpdateTriggerTrustIngressRefresh
   * @summary Refresh tenant trust page ingress
   * @request PATCH:/api/v1/tenants/{tenant}/trust-refresh-ingress
   * @secure
   */
  tenantUpdateTriggerTrustIngressRefresh = (tenant: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${tenant}/trust-refresh-ingress`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * @description Get the trust page documents for the current tenant
   *
   * @tags Tenant
   * @name TrustDocumentList
   * @summary Get tenant trust page documents
   * @request GET:/api/v1/tenants/{tenant}/trust-documents
   * @secure
   */
  trustDocumentList = (tenant: string, params: RequestParams = {}) =>
    this.request<TrustDocument[], APIError>({
      path: `/api/v1/tenants/${tenant}/trust-documents`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add to the trust page documents for the current tenant
   *
   * @tags Tenant, Trust
   * @name TrustDocumentCreate
   * @summary Add tenant trust page document
   * @request PUT:/api/v1/tenants/{tenant}/trust-documents
   * @secure
   */
  trustDocumentCreate = (tenant: string, data: TrustDocumentCreateRequest, params: RequestParams = {}) =>
    this.request<TrustDocument[], APIError>({
      path: `/api/v1/tenants/${tenant}/trust-documents`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all document requests submitted for a tenant.
   *
   * @tags Tenant, Trust
   * @name TenantGetTrustDocumentRequests
   * @summary List the document requests for a tenant.
   * @request GET:/api/v1/tenants/{tenant}/trust-document-requests
   * @secure
   */
  tenantGetTrustDocumentRequests = (tenant: string, params: RequestParams = {}) =>
    this.request<TrustDocumentResponse[], APIError>({
      path: `/api/v1/tenants/${tenant}/trust-document-requests`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update (approve or deny) a trust page document request
   *
   * @name TenantUpdateTrustDocumentRequest
   * @summary Update a trust page document request
   * @request PATCH:/api/v1/tenants/{tenant}/trust-document-requests
   * @secure
   */
  tenantUpdateTrustDocumentRequest = (tenant: string, data: TrustDocumentRequestUpdate, params: RequestParams = {}) =>
    this.request<TrustDocumentResponse, APIError>({
      path: `/api/v1/tenants/${tenant}/trust-document-requests`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request one or more documents for a given tenant
   *
   * @tags Tenant
   * @name TenantCreateTrustDocumentRequest
   * @summary Submit a request for one or more documents
   * @request POST:/api/v1/tenants/{slug}/request-trust-document
   */
  tenantCreateTrustDocumentRequest = (slug: string, data: TrustDocumentRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${slug}/request-trust-document`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description List all security issues reported for a tenant.
   *
   * @tags Tenant
   * @name TenantGetTrustSecurityIssues
   * @summary List the security issues reported for a tenant.
   * @request GET:/api/v1/tenants/{tenant}/trust-security-issues
   * @secure
   */
  tenantGetTrustSecurityIssues = (tenant: string, params: RequestParams = {}) =>
    this.request<TrustSecurityIssueResponse[], APIError>({
      path: `/api/v1/tenants/${tenant}/trust-security-issues`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update (resolve) a trust security issue report
   *
   * @name TenantUpdateTrustSecurityIssue
   * @summary Update (resolve) a trust security issue report
   * @request PATCH:/api/v1/tenants/{tenant}/trust-security-issues
   * @secure
   */
  tenantUpdateTrustSecurityIssue = (
    tenant: string,
    data: TrustSecurityIssueRequestUpdate,
    params: RequestParams = {},
  ) =>
    this.request<TrustSecurityIssueResponse, APIError>({
      path: `/api/v1/tenants/${tenant}/trust-security-issues`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Report a security issue for a given tenant
   *
   * @tags Tenant
   * @name TenantCreateTrustSecurityIssue
   * @summary Report a security issue for a given tenant
   * @request POST:/api/v1/tenants/{slug}/report-trust-security-issue
   */
  tenantCreateTrustSecurityIssue = (slug: string, data: TrustSecurityIssueRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${slug}/report-trust-security-issue`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Create a new engagement associated with a tenant.
   *
   * @tags Engagement
   * @name TenantCreateEngagement
   * @summary Create new engagement
   * @request POST:/api/v1/tenants/{tenant}/engagements
   * @secure
   */
  tenantCreateEngagement = (tenant: string, data: CreateEngagementRequest, params: RequestParams = {}) =>
    this.request<Engagement, APIError>({
      path: `/api/v1/tenants/${tenant}/engagements`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all engagements for a tenant.
   *
   * @tags Engagement
   * @name EngagementList
   * @summary List engagements
   * @request GET:/api/v1/tenants/{tenant}/engagements
   * @secure
   */
  engagementList = (tenant: string, params: RequestParams = {}) =>
    this.request<EngagementList, APIError>({
      path: `/api/v1/tenants/${tenant}/engagements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all invites for a tenant
   *
   * @tags Tenant
   * @name TenantInviteList
   * @summary Get tenant invites
   * @request GET:/api/v1/tenants/{tenant}/invites
   * @secure
   */
  tenantInviteList = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantInviteList, APIError>({
      path: `/api/v1/tenants/${tenant}/invites`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates an invite for a tenant
   *
   * @tags Tenant
   * @name TenantInviteCreate
   * @summary Create tenant invite
   * @request POST:/api/v1/tenants/{tenant}/invites
   * @secure
   */
  tenantInviteCreate = (tenant: string, data: CreateTenantInviteRequest, params: RequestParams = {}) =>
    this.request<TenantInvite, APIError>({
      path: `/api/v1/tenants/${tenant}/invites`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger Section III AI workflow for a tenant
   *
   * @tags AI
   * @name TenantUpdateTriggerSectionIii
   * @summary Trigger Section III workflow
   * @request POST:/api/v1/tenants/{tenant}/section-iii/trigger
   * @secure
   */
  tenantUpdateTriggerSectionIii = (tenant: string, params: RequestParams = {}) =>
    this.request<
      {
        workflowId?: string;
        message?: string;
      },
      APIError
    >({
      path: `/api/v1/tenants/${tenant}/section-iii/trigger`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all reports for a tenant.
   *
   * @tags Report
   * @name TenantReportsList
   * @summary List reports by tenant
   * @request GET:/api/v1/tenants/{tenant}/reports
   * @secure
   */
  tenantReportsList = (tenant: string, params: RequestParams = {}) =>
    this.request<ReportList, APIError>({
      path: `/api/v1/tenants/${tenant}/reports`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all feature flags for a tenant
   *
   * @name TenantFeatureFlagsList
   * @summary Get tenant feature flags
   * @request GET:/api/v1/tenants/{tenant}/feature-flags
   * @secure
   */
  tenantFeatureFlagsList = (tenant: string, params: RequestParams = {}) =>
    this.request<FeatureFlagList, APIError>({
      path: `/api/v1/tenants/${tenant}/feature-flags`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add feature flag to tenant
   *
   * @name TenantCreateFeatureFlag
   * @summary Add feature flag to tenant
   * @request POST:/api/v1/tenants/{tenant}/feature-flags
   * @secure
   */
  tenantCreateFeatureFlag = (tenant: string, data: AddFeatureFlagRequest, params: RequestParams = {}) =>
    this.request<FeatureFlag, APIError>({
      path: `/api/v1/tenants/${tenant}/feature-flags`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove feature flag from tenant
   *
   * @name TenantDeleteFeatureFlag
   * @summary Remove feature flag from tenant
   * @request DELETE:/api/v1/tenants/{tenant}/feature-flags/{feature-flag}
   * @secure
   */
  tenantDeleteFeatureFlag = (tenant: string, featureFlag: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${tenant}/feature-flags/${featureFlag}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Enable or disable the SLAs feature flag for a tenant
   *
   * @tags Tenant
   * @name TenantUpdateSlasFeatureFlag
   * @summary Update SLA feature flag status
   * @request PATCH:/api/v1/tenants/{tenant}/slas
   * @secure
   */
  tenantUpdateSlasFeatureFlag = (
    tenant: string,
    data: {
      /** Whether the SLAs feature flag should be enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Current status of the SLAs feature flag */
        enabled?: boolean;
      },
      APIError
    >({
      path: `/api/v1/tenants/${tenant}/slas`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a tenant employee
   *
   * @name TenantEmployeeCreate
   * @summary Create a tenant employee
   * @request POST:/api/v1/tenants/{tenant}/employees
   * @secure
   */
  tenantEmployeeCreate = (tenant: string, data: TenantEmployeeCreateRequest, params: RequestParams = {}) =>
    this.request<TenantMember, APIError>({
      path: `/api/v1/tenants/${tenant}/employees`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get or create settings for the tenant
   *
   * @tags Tenant
   * @name TenantGetSettings
   * @summary Get or create settings for the tenant
   * @request GET:/api/v1/tenants/{tenant}/settings
   * @secure
   */
  tenantGetSettings = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantSettings, APIError>({
      path: `/api/v1/tenants/${tenant}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates tenants for the current user
   *
   * @tags Tenant
   * @name TenantUpdateSettings
   * @summary Updates tenants for the current user
   * @request PUT:/api/v1/tenants/{tenant}/settings
   * @secure
   */
  tenantUpdateSettings = (tenant: string, data: UpdateTenantSettingsRequest, params: RequestParams = {}) =>
    this.request<TenantSettings, APIError>({
      path: `/api/v1/tenants/${tenant}/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all checklist templates for a tenant
   *
   * @tags ChecklistTemplate
   * @name ChecklistTemplateList
   * @summary Get tenant checklist templates
   * @request GET:/api/v1/tenants/{tenant}/checklist-templates
   * @secure
   */
  checklistTemplateList = (tenant: string, params: RequestParams = {}) =>
    this.request<ChecklistTemplateList, APIError>({
      path: `/api/v1/tenants/${tenant}/checklist-templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a checklist template for a tenant
   *
   * @tags Checklist
   * @name ChecklistTemplateCreate
   * @summary Create checklist template
   * @request POST:/api/v1/tenants/{tenant}/checklist-templates
   * @secure
   */
  checklistTemplateCreate = (tenant: string, data: CreateChecklistTemplateRequest, params: RequestParams = {}) =>
    this.request<ChecklistTemplate, APIError>({
      path: `/api/v1/tenants/${tenant}/checklist-templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get audit logs for a tenant
   *
   * @name TenantGetAuditLogs
   * @summary Get audit logs for a tenant
   * @request GET:/api/v1/tenants/{tenant}/audit-logs
   * @secure
   */
  tenantGetAuditLogs = (
    tenant: string,
    query?: {
      /** The cursor to use to get the next page of audit logs */
      cursor?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AuditLogList, APIError>({
      path: `/api/v1/tenants/${tenant}/audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all exposed accounts for the current tenant
   *
   * @tags Exposed Account, Tenant
   * @name TenantGetExposedAccounts
   * @summary Get all exposed accounts for tenant
   * @request GET:/api/v1/tenants/{tenant}/exposed-accounts
   * @secure
   */
  tenantGetExposedAccounts = (tenant: string, params: RequestParams = {}) =>
    this.request<ExposedAccount[], APIError>({
      path: `/api/v1/tenants/${tenant}/exposed-accounts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a trust page document for the current tenant
   *
   * @tags Tenant, Trust
   * @name TrustDocumentDelete
   * @summary Remove tenant trust page document
   * @request DELETE:/api/v1/trust-documents/{trust-document}
   * @secure
   */
  trustDocumentDelete = (trustDocument: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/trust-documents/${trustDocument}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List the groups under a tenant.
   *
   * @tags Groups
   * @name GroupList
   * @summary List the groups under a tenant.
   * @request GET:/api/v1/tenants/{tenant}/groups
   * @secure
   */
  groupList = (tenant: string, params: RequestParams = {}) =>
    this.request<Group[], APIError>({
      path: `/api/v1/tenants/${tenant}/groups`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new group for a tenant.
   *
   * @name GroupCreate
   * @summary Create a new group for a tenant.
   * @request POST:/api/v1/tenants/{tenant}/groups
   * @secure
   */
  groupCreate = (tenant: string, data: CreateGroupRequest, params: RequestParams = {}) =>
    this.request<Group, APIError>({
      path: `/api/v1/tenants/${tenant}/groups`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a group by ID.
   *
   * @name GroupGet
   * @summary Get a group by ID.
   * @request GET:/api/v1/groups/{group}
   * @secure
   */
  groupGet = (group: string, params: RequestParams = {}) =>
    this.request<Group, APIError>({
      path: `/api/v1/groups/${group}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a group by ID.
   *
   * @name GroupUpdate
   * @summary Update a group by ID.
   * @request PATCH:/api/v1/groups/{group}
   * @secure
   */
  groupUpdate = (group: string, data: UpdateGroupRequest, params: RequestParams = {}) =>
    this.request<Group, APIError>({
      path: `/api/v1/groups/${group}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a group by ID.
   *
   * @name GroupDelete
   * @summary Delete a group by ID.
   * @request DELETE:/api/v1/groups/{group}
   * @secure
   */
  groupDelete = (group: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/groups/${group}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List access reviews for tenant.
   *
   * @tags Access Reviews
   * @name AccessReviewList
   * @summary List access reviews.
   * @request GET:/api/v1/tenants/{tenant}/access-reviews
   * @secure
   */
  accessReviewList = (tenant: string, params: RequestParams = {}) =>
    this.request<AccessReview[], APIError>({
      path: `/api/v1/tenants/${tenant}/access-reviews`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create access review for tenant.
   *
   * @tags Access Reviews
   * @name AccessReviewCreate
   * @summary Create access review.
   * @request POST:/api/v1/tenants/{tenant}/access-reviews
   * @secure
   */
  accessReviewCreate = (tenant: string, data: CreateAccessReviewRequest, params: RequestParams = {}) =>
    this.request<AccessReview, APIError>({
      path: `/api/v1/tenants/${tenant}/access-reviews`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get access review details.
   *
   * @tags Access Reviews
   * @name AccessReviewGet
   * @summary Get access review details.
   * @request GET:/api/v1/access-reviews/{access-review}
   * @secure
   */
  accessReviewGet = (accessReview: string, params: RequestParams = {}) =>
    this.request<AccessReview, APIError>({
      path: `/api/v1/access-reviews/${accessReview}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update access review.
   *
   * @tags Access Reviews
   * @name AccessReviewUpdate
   * @summary Update access review.
   * @request PATCH:/api/v1/access-reviews/{access-review}
   * @secure
   */
  accessReviewUpdate = (accessReview: string, data: UpdateAccessReviewRequest, params: RequestParams = {}) =>
    this.request<AccessReview, APIError>({
      path: `/api/v1/access-reviews/${accessReview}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete access review.
   *
   * @tags Access Reviews
   * @name AccessReviewDelete
   * @summary Delete access review.
   * @request DELETE:/api/v1/access-reviews/{access-review}
   * @secure
   */
  accessReviewDelete = (accessReview: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/access-reviews/${accessReview}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Restore a soft-deleted access review.
   *
   * @tags Access Reviews
   * @name AccessReviewUpdateRestore
   * @summary Restore an access review.
   * @request POST:/api/v1/access-reviews/{access-review}/restore
   * @secure
   */
  accessReviewUpdateRestore = (accessReview: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/access-reviews/${accessReview}/restore`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Add a vendor to access review.
   *
   * @tags Access Reviews
   * @name AccessReviewVendorCreate
   * @summary Add a vendor to access review.
   * @request POST:/api/v1/access-reviews/{access-review}/create-vendor
   * @secure
   */
  accessReviewVendorCreate = (accessReview: string, data: TenantVendorWithReviewer, params: RequestParams = {}) =>
    this.request<AccessReview, APIError>({
      path: `/api/v1/access-reviews/${accessReview}/create-vendor`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create an access review account for an access review.
   *
   * @tags Access Reviews
   * @name AccessReviewAccountCreate
   * @summary Create an access review account.
   * @request POST:/api/v1/access-reviews/{access-review}/create-account
   * @secure
   */
  accessReviewAccountCreate = (
    accessReview: string,
    data: CreateAccessReviewAccountRequest,
    params: RequestParams = {},
  ) =>
    this.request<AccessReviewAccount, APIError>({
      path: `/api/v1/access-reviews/${accessReview}/create-account`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List the access review accounts for tenant member.
   *
   * @tags Access Reviews
   * @name AccessReviewAccountListTenantMember
   * @summary List the access review accounts for a tenant member.
   * @request GET:/api/v1/access-reviews/{access-review}/accounts
   * @secure
   */
  accessReviewAccountListTenantMember = (
    accessReview: string,
    query: {
      /**
       * The id of the tenant member
       * @format uuid
       * @minLength 36
       * @maxLength 36
       */
      tenantMemberId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AccessReviewAccountForTenantMember[], APIError>({
      path: `/api/v1/access-reviews/${accessReview}/accounts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an access review vendor
   *
   * @tags Access Reviews
   * @name AccessReviewVendorUpdate
   * @summary Update an access review vendor
   * @request PATCH:/api/v1/access-review-vendors/{access-review-vendor}
   * @secure
   */
  accessReviewVendorUpdate = (
    accessReviewVendor: string,
    data: UpdateAccessReviewVendorRequest,
    params: RequestParams = {},
  ) =>
    this.request<AccessReviewVendor, APIError>({
      path: `/api/v1/access-review-vendors/${accessReviewVendor}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a vendor from access review.
   *
   * @tags Access Reviews
   * @name AccessReviewVendorDelete
   * @summary Remove a vendor from access review.
   * @request DELETE:/api/v1/access-review-vendors/{access-review-vendor}
   * @secure
   */
  accessReviewVendorDelete = (accessReviewVendor: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/access-review-vendors/${accessReviewVendor}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Update access review account status.
   *
   * @tags Access Reviews
   * @name AccessReviewAccountUpdate
   * @summary Update access review account status.
   * @request PATCH:/api/v1/access-review-accounts/{access-review-account}
   * @secure
   */
  accessReviewAccountUpdate = (
    accessReviewAccount: string,
    data: UpdateAccessReviewAccountRequest,
    params: RequestParams = {},
  ) =>
    this.request<AccessReviewAccount, APIError>({
      path: `/api/v1/access-review-accounts/${accessReviewAccount}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a checklist template by id.
   *
   * @tags ChecklistTemplate
   * @name ChecklistTemplateGet
   * @summary Get checklist template
   * @request GET:/api/v1/checklist-templates/{checklist-template}
   * @secure
   */
  checklistTemplateGet = (checklistTemplate: string, params: RequestParams = {}) =>
    this.request<ChecklistTemplate, APIError>({
      path: `/api/v1/checklist-templates/${checklistTemplate}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a checklist template by id.
   *
   * @tags ChecklistTemplate
   * @name ChecklistTemplateDelete
   * @summary Delete checklist template
   * @request DELETE:/api/v1/checklist-templates/{checklist-template}
   * @secure
   */
  checklistTemplateDelete = (checklistTemplate: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/checklist-templates/${checklistTemplate}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create a checklist template item
   *
   * @tags ChecklistTemplate
   * @name ChecklistTemplateItemCreate
   * @summary Create a checklist template item
   * @request POST:/api/v1/checklist-templates/{checklist-template}/items
   * @secure
   */
  checklistTemplateItemCreate = (
    checklistTemplate: string,
    data: CreateChecklistTemplateItemRequest,
    params: RequestParams = {},
  ) =>
    this.request<ChecklistTemplateItem, APIError>({
      path: `/api/v1/checklist-templates/${checklistTemplate}/items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates a checklist template item
   *
   * @tags ChecklistTemplate
   * @name ChecklistTemplateItemUpdate
   * @summary Update checklist template item
   * @request PATCH:/api/v1/checklist-template-items/{checklist-template-item}
   * @secure
   */
  checklistTemplateItemUpdate = (
    checklistTemplateItem: string,
    data: UpdateChecklistTemplateItemRequest,
    params: RequestParams = {},
  ) =>
    this.request<ChecklistTemplateItem, APIError>({
      path: `/api/v1/checklist-template-items/${checklistTemplateItem}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a checklist template item by id.
   *
   * @tags ChecklistTemplate
   * @name ChecklistTemplateItemDelete
   * @summary Delete checklist template item
   * @request DELETE:/api/v1/checklist-template-items/{checklist-template-item}
   * @secure
   */
  checklistTemplateItemDelete = (checklistTemplateItem: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/checklist-template-items/${checklistTemplateItem}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Lists all checklist templates for a tenant member
   *
   * @tags MemberChecklist
   * @name MemberChecklistList
   * @summary Get tenant member checklists
   * @request GET:/api/v1/tenant-members/{tenant-member}/checklists
   * @secure
   */
  memberChecklistList = (tenantMember: string, params: RequestParams = {}) =>
    this.request<MemberChecklists, APIError>({
      path: `/api/v1/tenant-members/${tenantMember}/checklists`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new checklist instance for a tenant member
   *
   * @tags MemberChecklist
   * @name MemberChecklistCreate
   * @summary Create a tenant member checklist
   * @request POST:/api/v1/tenant-members/{tenant-member}/checklists
   * @secure
   */
  memberChecklistCreate = (tenantMember: string, data: CreateMemberChecklistRequest, params: RequestParams = {}) =>
    this.request<MemberChecklist, APIError>({
      path: `/api/v1/tenant-members/${tenantMember}/checklists`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a member checklist by id.
   *
   * @tags MemberChecklist
   * @name MemberChecklistGet
   * @summary Get tenant member checklist items
   * @request GET:/api/v1/member-checklists/{member-checklist}
   * @secure
   */
  memberChecklistGet = (memberChecklist: string, params: RequestParams = {}) =>
    this.request<MemberChecklist, APIError>({
      path: `/api/v1/member-checklists/${memberChecklist}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a checklist instance for a tenant member
   *
   * @tags MemberChecklist
   * @name MemberChecklistDelete
   * @summary Delete a tenant member checklist
   * @request DELETE:/api/v1/member-checklists/{member-checklist}
   * @secure
   */
  memberChecklistDelete = (memberChecklist: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/member-checklists/${memberChecklist}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new checklist item instance for a tenant member
   *
   * @tags MemberChecklist
   * @name MemberChecklistItemCreate
   * @summary Create a tenant member checklist item
   * @request POST:/api/v1/member-checklists/{member-checklist}/items
   * @secure
   */
  memberChecklistItemCreate = (
    memberChecklist: string,
    data: CreateMemberChecklistItemRequest,
    params: RequestParams = {},
  ) =>
    this.request<MemberChecklistItem, APIError>({
      path: `/api/v1/member-checklists/${memberChecklist}/items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Resets a checklist instance for a tenant member
   *
   * @tags MemberChecklist
   * @name MemberChecklistUpdateReset
   * @summary Reset a tenant member checklist
   * @request PATCH:/api/v1/member-checklists/{member-checklist}/reset
   * @secure
   */
  memberChecklistUpdateReset = (memberChecklist: string, params: RequestParams = {}) =>
    this.request<MemberChecklist, APIError>({
      path: `/api/v1/member-checklists/${memberChecklist}/reset`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Batch updates multiple items in a checklist
   *
   * @tags MemberChecklist
   * @name MemberChecklistUpdate
   * @summary Batch update a tenant member checklist
   * @request PATCH:/api/v1/member-checklists/{member-checklist}/update-items
   * @secure
   */
  memberChecklistUpdate = (memberChecklist: string, data: UpdateMemberChecklistRequest, params: RequestParams = {}) =>
    this.request<MemberChecklist, APIError>({
      path: `/api/v1/member-checklists/${memberChecklist}/update-items`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates a checklist item instance for a tenant member
   *
   * @tags MemberChecklist
   * @name MemberChecklistItemUpdate
   * @summary Update a tenant member checklist item
   * @request PATCH:/api/v1/member-checklist-items/{member-checklist-item}
   * @secure
   */
  memberChecklistItemUpdate = (
    memberChecklistItem: string,
    data: UpdateMemberChecklistItemRequest,
    params: RequestParams = {},
  ) =>
    this.request<MemberChecklistItem, APIError>({
      path: `/api/v1/member-checklist-items/${memberChecklistItem}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a checklist item instance for a tenant member
   *
   * @tags MemberChecklist
   * @name MemberChecklistItemDelete
   * @summary Delete a tenant member checklist item
   * @request DELETE:/api/v1/member-checklist-items/{member-checklist-item}
   * @secure
   */
  memberChecklistItemDelete = (memberChecklistItem: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/member-checklist-items/${memberChecklistItem}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Rejects a tenant invite
   *
   * @tags Invite
   * @name InviteUpdateReject
   * @summary Reject a tenant invite
   * @request POST:/api/v1/invites/{invite}/reject
   * @secure
   */
  inviteUpdateReject = (invite: string, params: RequestParams = {}) =>
    this.request<TenantInvite, APIError>({
      path: `/api/v1/invites/${invite}/reject`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Accepts a tenant invite
   *
   * @tags Invite
   * @name InviteUpdateAccept
   * @summary Accept a tenant invite
   * @request POST:/api/v1/invites/{invite}/accept
   * @secure
   */
  inviteUpdateAccept = (invite: string, params: RequestParams = {}) =>
    this.request<TenantInvite, APIError>({
      path: `/api/v1/invites/${invite}/accept`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Disables a tenant invite
   *
   * @tags Invite
   * @name InviteUpdateDisable
   * @summary Disable a tenant invite
   * @request POST:/api/v1/invites/{invite}/disable
   * @secure
   */
  inviteUpdateDisable = (invite: string, params: RequestParams = {}) =>
    this.request<TenantInvite, APIError>({
      path: `/api/v1/invites/${invite}/disable`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Resends a tenant invite
   *
   * @tags Invite
   * @name InviteUpdateResend
   * @summary Resend a tenant invite
   * @request POST:/api/v1/invites/{invite}/resend
   * @secure
   */
  inviteUpdateResend = (invite: string, params: RequestParams = {}) =>
    this.request<TenantInvite, APIError>({
      path: `/api/v1/invites/${invite}/resend`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all engagements (superadmin endpoint)
   *
   * @tags Engagement
   * @name AdminListEngagements
   * @summary List engagements
   * @request GET:/api/v1/engagements
   * @secure
   */
  adminListEngagements = (params: RequestParams = {}) =>
    this.request<EngagementList, APIError>({
      path: `/api/v1/engagements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets an engagement by id.
   *
   * @tags Engagement
   * @name EngagementGet
   * @summary Get engagement
   * @request GET:/api/v1/engagements/{engagement}
   * @secure
   */
  engagementGet = (engagement: string, params: RequestParams = {}) =>
    this.request<Engagement, APIError>({
      path: `/api/v1/engagements/${engagement}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an engagement by id.
   *
   * @tags Engagement
   * @name EngagementUpdate
   * @summary Get engagement
   * @request PATCH:/api/v1/engagements/{engagement}
   * @secure
   */
  engagementUpdate = (engagement: string, data: UpdateEngagementRequest, params: RequestParams = {}) =>
    this.request<Engagement, APIError>({
      path: `/api/v1/engagements/${engagement}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes an engagement by id.
   *
   * @tags Engagement
   * @name EngagementDelete
   * @summary Delete engagement
   * @request DELETE:/api/v1/engagements/{engagement}
   * @secure
   */
  engagementDelete = (engagement: string, params: RequestParams = {}) =>
    this.request<Engagement, APIError>({
      path: `/api/v1/engagements/${engagement}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a list of policy types
   *
   * @tags Policy Type
   * @name PolicyTypeList
   * @summary Get policy types
   * @request GET:/api/v1/policy-types
   * @secure
   */
  policyTypeList = (params: RequestParams = {}) =>
    this.request<PolicyTypeList, APIError>({
      path: `/api/v1/policy-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets the shared data to populate a template
   *
   * @tags Policy Template
   * @name TenantGetPolicyTemplateSharedData
   * @summary Get shared data
   * @request GET:/api/v1/tenants/{tenant}/policy-templates/shared-data
   * @secure
   */
  tenantGetPolicyTemplateSharedData = (tenant: string, params: RequestParams = {}) =>
    this.request<SharedData, APIError>({
      path: `/api/v1/tenants/${tenant}/policy-templates/shared-data`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a list of policy templates.
   *
   * @tags Policy Template
   * @name PolicyTemplateList
   * @summary Get policy templates
   * @request GET:/api/v1/policy-templates
   * @secure
   */
  policyTemplateList = (params: RequestParams = {}) =>
    this.request<PolicyTemplateList, APIError>({
      path: `/api/v1/policy-templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a policy template.
   *
   * @tags Policy Template
   * @name PolicyTemplateGet
   * @summary Get policy template
   * @request GET:/api/v1/policy-templates/{policy-template}
   * @secure
   */
  policyTemplateGet = (policyTemplate: string, params: RequestParams = {}) =>
    this.request<PolicyTemplate, APIError>({
      path: `/api/v1/policy-templates/${policyTemplate}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a list of policies.
   *
   * @tags Policy
   * @name PolicyList
   * @summary Get policies
   * @request GET:/api/v1/tenants/{tenant}/policies
   * @secure
   */
  policyList = (tenant: string, params: RequestParams = {}) =>
    this.request<PolicyList, APIError>({
      path: `/api/v1/tenants/${tenant}/policies`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new policy.
   *
   * @tags Policy
   * @name PolicyCreate
   * @summary Create policy
   * @request POST:/api/v1/tenants/{tenant}/policies
   * @secure
   */
  policyCreate = (tenant: string, data: CreatePolicyRequest, params: RequestParams = {}) =>
    this.request<Policy, APIError>({
      path: `/api/v1/tenants/${tenant}/policies`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a list of policies for the current user.
   *
   * @tags Policy
   * @name PolicyListMe
   * @summary Get the current user's policies
   * @request GET:/api/v1/tenants/{tenant}/policies/me
   * @secure
   */
  policyListMe = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantMemberApplicablePolicy[], APIError>({
      path: `/api/v1/tenants/${tenant}/policies/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a policy.
   *
   * @tags Policy
   * @name PolicyGet
   * @summary Get policy
   * @request GET:/api/v1/policies/{policy}
   * @secure
   */
  policyGet = (policy: string, params: RequestParams = {}) =>
    this.request<Policy, APIError>({
      path: `/api/v1/policies/${policy}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a policy by id
   *
   * @tags Policy
   * @name PolicyUpdate
   * @summary Update policy
   * @request PATCH:/api/v1/policies/{policy}
   * @secure
   */
  policyUpdate = (policy: string, data: UpdatePolicyRequest, params: RequestParams = {}) =>
    this.request<Policy, APIError>({
      path: `/api/v1/policies/${policy}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a policy.
   *
   * @tags Policy
   * @name PolicyDelete
   * @summary Delete policy
   * @request DELETE:/api/v1/policies/{policy}
   * @secure
   */
  policyDelete = (policy: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/policies/${policy}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Gets a policy for the current user.
   *
   * @tags Policy
   * @name PolicyGetMe
   * @summary Get the current user's policy
   * @request GET:/api/v1/policies/{policy}/me
   * @secure
   */
  policyGetMe = (policy: string, params: RequestParams = {}) =>
    this.request<TenantMemberApplicablePolicy, APIError>({
      path: `/api/v1/policies/${policy}/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets the list of versions for a policy
   *
   * @tags Policy, Policy Version
   * @name PolicyVersionList
   * @summary Get policy versions
   * @request GET:/api/v1/policies/{policy}/versions
   * @secure
   */
  policyVersionList = (policy: string, params: RequestParams = {}) =>
    this.request<PolicyVersionList, APIError>({
      path: `/api/v1/policies/${policy}/versions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new policy version
   *
   * @tags Policy Version
   * @name PolicyVersionCreate
   * @summary Create policy version
   * @request POST:/api/v1/policies/{policy}/versions
   * @secure
   */
  policyVersionCreate = (policy: string, params: RequestParams = {}) =>
    this.request<PolicyVersion, APIError>({
      path: `/api/v1/policies/${policy}/versions`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a policy version
   *
   * @tags Policy Version
   * @name PolicyVersionGet
   * @summary Get policy version
   * @request GET:/api/v1/policy-versions/{policy-version}
   * @secure
   */
  policyVersionGet = (policyVersion: string, params: RequestParams = {}) =>
    this.request<PolicyVersion, APIError>({
      path: `/api/v1/policy-versions/${policyVersion}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates a policy version
   *
   * @tags Policy Version
   * @name PolicyVersionUpdate
   * @summary Update policy version
   * @request PATCH:/api/v1/policy-versions/{policy-version}
   * @secure
   */
  policyVersionUpdate = (policyVersion: string, data: UpdatePolicyVersionRequest, params: RequestParams = {}) =>
    this.request<PolicyVersion, APIError>({
      path: `/api/v1/policy-versions/${policyVersion}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a policy version
   *
   * @tags Policy Version
   * @name PolicyVersionDelete
   * @summary Delete policy version
   * @request DELETE:/api/v1/policy-versions/{policy-version}
   * @secure
   */
  policyVersionDelete = (policyVersion: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/policy-versions/${policyVersion}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Publish a policy version.
   *
   * @tags Policy Version
   * @name PolicyVersionUpdatePublish
   * @summary Publish policy version
   * @request POST:/api/v1/policy-versions/{policy-version}/publish
   * @secure
   */
  policyVersionUpdatePublish = (policyVersion: string, data: PublishPolicyVersionRequest, params: RequestParams = {}) =>
    this.request<PolicyVersion, APIError>({
      path: `/api/v1/policy-versions/${policyVersion}/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all signatures for a policy.
   *
   * @tags Policy Version, Policy Signature
   * @name PolicySignatureList
   * @summary Get signatures for a policy
   * @request GET:/api/v1/policy-versions/{policy-version}/signatures
   * @secure
   */
  policySignatureList = (policyVersion: string, params: RequestParams = {}) =>
    this.request<PolicySignatureList, APIError>({
      path: `/api/v1/policy-versions/${policyVersion}/signatures`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new signature for a policy version.
   *
   * @tags Policy Signature, Policy Version
   * @name PolicySignatureCreate
   * @summary Sign a policy version
   * @request POST:/api/v1/policy-versions/{policy-version}/signatures
   * @secure
   */
  policySignatureCreate = (policyVersion: string, params: RequestParams = {}) =>
    this.request<PolicySignature, APIError>({
      path: `/api/v1/policy-versions/${policyVersion}/signatures`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all testers (superadmin endpoint)
   *
   * @tags Tester
   * @name AdminListTesters
   * @summary List testers
   * @request GET:/api/v1/testers
   * @secure
   */
  adminListTesters = (params: RequestParams = {}) =>
    this.request<UserList, APIError>({
      path: `/api/v1/testers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Invite a tester to the platform
   *
   * @tags Tester
   * @name TesterCreateInvite
   * @summary Invite a tester
   * @request POST:/api/v1/testers/invite
   * @secure
   */
  testerCreateInvite = (data: CreateTesterInviteRequest, params: RequestParams = {}) =>
    this.request<TesterInvite, APIError>({
      path: `/api/v1/testers/invite`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Accept an invite to the platform
   *
   * @tags Tester
   * @name CurrentTesterUpdateAcceptInvite
   * @summary Invite a tester
   * @request POST:/api/v1/testers/invites/{testerinvite}/accept
   * @secure
   */
  currentTesterUpdateAcceptInvite = (testerinvite: string, params: RequestParams = {}) =>
    this.request<User, APIError>({
      path: `/api/v1/testers/invites/${testerinvite}/accept`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Assign a tester to an engagement
   *
   * @tags Tester
   * @name TesterUpdateAssign
   * @summary Assign a tester
   * @request POST:/api/v1/testers/{tester}/assign
   * @secure
   */
  testerUpdateAssign = (tester: string, data: AssignTesterRequest, params: RequestParams = {}) =>
    this.request<TenantTester, APIError>({
      path: `/api/v1/testers/${tester}/assign`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Unassign a tester from an engagement
   *
   * @tags Tester
   * @name TesterUpdateUnassign
   * @summary Unassign a tester
   * @request POST:/api/v1/testers/{tester}/unassign
   * @secure
   */
  testerUpdateUnassign = (tester: string, data: UnassignTesterRequest, params: RequestParams = {}) =>
    this.request<TenantTester, APIError>({
      path: `/api/v1/testers/${tester}/unassign`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all engagements for the current tester
   *
   * @tags Tester
   * @name CurrentTesterListEngagements
   * @summary List engagements for the current tester
   * @request GET:/api/v1/testers/current/engagements
   * @secure
   */
  currentTesterListEngagements = (params: RequestParams = {}) =>
    this.request<EngagementList, APIError>({
      path: `/api/v1/testers/current/engagements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all engagements for a tester
   *
   * @tags Tester
   * @name TesterListEngagements
   * @summary List engagements for a tester
   * @request GET:/api/v1/testers/{tester}/engagements
   * @secure
   */
  testerListEngagements = (tester: string, params: RequestParams = {}) =>
    this.request<EngagementList, APIError>({
      path: `/api/v1/testers/${tester}/engagements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all invites for the current tester
   *
   * @tags Tester
   * @name CurrentTesterListInvites
   * @summary List invites for the current tester
   * @request GET:/api/v1/testers/current/invites
   * @secure
   */
  currentTesterListInvites = (params: RequestParams = {}) =>
    this.request<TesterInviteList, APIError>({
      path: `/api/v1/testers/current/invites`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all findings the current tester
   *
   * @tags Tester
   * @name CurrentTesterListFindings
   * @summary List findings for the current tester
   * @request GET:/api/v1/testers/current/findings
   * @secure
   */
  currentTesterListFindings = (params: RequestParams = {}) =>
    this.request<FindingList, APIError>({
      path: `/api/v1/testers/current/findings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all findings for a tester
   *
   * @tags Tester
   * @name TesterListFindings
   * @summary List findings for a tester
   * @request GET:/api/v1/testers/{tester}/findings
   * @secure
   */
  testerListFindings = (tester: string, params: RequestParams = {}) =>
    this.request<FindingList, APIError>({
      path: `/api/v1/testers/${tester}/findings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new report for an engagement.
   *
   * @tags Report
   * @name ReportCreate
   * @summary Create report
   * @request POST:/api/v1/engagements/{engagement}/reports
   * @secure
   */
  reportCreate = (engagement: string, data: CreateReportRequest, params: RequestParams = {}) =>
    this.request<Report, APIError>({
      path: `/api/v1/engagements/${engagement}/reports`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all reports for an engagement.
   *
   * @tags Report
   * @name ReportList
   * @summary List reports
   * @request GET:/api/v1/engagements/{engagement}/reports
   * @secure
   */
  reportList = (engagement: string, params: RequestParams = {}) =>
    this.request<ReportList, APIError>({
      path: `/api/v1/engagements/${engagement}/reports`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates a report.
   *
   * @tags Report
   * @name ReportUpdate
   * @summary Update report
   * @request PATCH:/api/v1/reports/{report}
   * @secure
   */
  reportUpdate = (report: string, data: UpdateReportRequest, params: RequestParams = {}) =>
    this.request<Report, APIError>({
      path: `/api/v1/reports/${report}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches a report.
   *
   * @tags Report
   * @name ReportGet
   * @summary Get report
   * @request GET:/api/v1/reports/{report}
   * @secure
   */
  reportGet = (
    report: string,
    query?: {
      /**
       * The snapshot id (optional)
       * @format uuid
       * @minLength 36
       * @maxLength 36
       */
      snapshot?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Report, APIError>({
      path: `/api/v1/reports/${report}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a report.
   *
   * @tags Report
   * @name ReportDelete
   * @summary Delete report
   * @request DELETE:/api/v1/reports/{report}
   * @secure
   */
  reportDelete = (report: string, params: RequestParams = {}) =>
    this.request<Report, APIError>({
      path: `/api/v1/reports/${report}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Request a report.
   *
   * @tags Report
   * @name ReportUpdateRequest
   * @summary Request report
   * @request POST:/api/v1/reports/{report}/request
   * @secure
   */
  reportUpdateRequest = (report: string, params: RequestParams = {}) =>
    this.request<Report, APIError>({
      path: `/api/v1/reports/${report}/request`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Publish a report.
   *
   * @tags Report
   * @name ReportUpdatePublish
   * @summary Publish report
   * @request POST:/api/v1/reports/{report}/publish
   * @secure
   */
  reportUpdatePublish = (
    report: string,
    data: {
      /** @format binary */
      upload?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/reports/${report}/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * @description Prepublish a report.
   *
   * @tags Report
   * @name ReportUpdatePrepublish
   * @summary Prepublish report
   * @request POST:/api/v1/reports/{report}/prepublish
   * @secure
   */
  reportUpdatePrepublish = (report: string, params: RequestParams = {}) =>
    this.request<Report, APIError>({
      path: `/api/v1/reports/${report}/prepublish`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all versions (snapshots) of a report.
   *
   * @tags Report
   * @name ReportVersionList
   * @summary List report versions
   * @request GET:/api/v1/reports/{report}/versions
   * @secure
   */
  reportVersionList = (report: string, params: RequestParams = {}) =>
    this.request<ReportVersionList, APIError>({
      path: `/api/v1/reports/${report}/versions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update published report PDF.
   *
   * @tags Report
   * @name ReportUpdateUpdatepdf
   * @summary Update report PDF
   * @request POST:/api/v1/reports/{report}/snapshots/{snapshot}/updatepdf
   * @secure
   */
  reportUpdateUpdatepdf = (
    report: string,
    snapshot: string,
    data: {
      /** @format binary */
      upload?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/reports/${report}/snapshots/${snapshot}/updatepdf`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * @description Download the report PDF.
   *
   * @tags Report
   * @name ReportGetDownload
   * @summary Download report
   * @request GET:/api/v1/reports/{report}/download
   * @secure
   */
  reportGetDownload = (
    report: string,
    query: {
      /** The report version */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ReportDownloadResponse, APIError>({
      path: `/api/v1/reports/${report}/download`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a finding by id.
   *
   * @tags Finding
   * @name ScanFindingGet
   * @summary Get finding
   * @request GET:/api/v1/scan-findings/{scan-finding}
   * @secure
   */
  scanFindingGet = (scanFinding: string, params: RequestParams = {}) =>
    this.request<Finding, APIError>({
      path: `/api/v1/scan-findings/${scanFinding}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a finding state.
   *
   * @tags Finding
   * @name ScanFindingUpdateState
   * @summary Update finding
   * @request PATCH:/api/v1/scan-findings/{scan-finding}
   * @secure
   */
  scanFindingUpdateState = (scanFinding: string, data: UpdateScanFindingState, params: RequestParams = {}) =>
    this.request<Finding, APIError>({
      path: `/api/v1/scan-findings/${scanFinding}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request assistance to fix an scan finding.
   *
   * @tags Finding
   * @name ScanFindingUpdateAssistance
   * @summary Request assistance
   * @request PATCH:/api/v1/scan-findings/{scan-finding}/request-assistance
   * @secure
   */
  scanFindingUpdateAssistance = (scanFinding: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/scan-findings/${scanFinding}/request-assistance`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * @description List all findings for a report.
   *
   * @tags Finding
   * @name FindingList
   * @summary Get findings
   * @request GET:/api/v1/reports/{report}/findings
   * @secure
   */
  findingList = (
    report: string,
    query?: {
      /**
       * The snapshot id (optional)
       * @format uuid
       * @minLength 36
       * @maxLength 36
       */
      snapshot?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<FindingList, APIError>({
      path: `/api/v1/reports/${report}/findings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new finding for a report.
   *
   * @tags Finding
   * @name FindingCreate
   * @summary Create finding
   * @request POST:/api/v1/reports/{report}/findings
   * @secure
   */
  findingCreate = (report: string, data: CreateFindingRequest, params: RequestParams = {}) =>
    this.request<Finding, APIError>({
      path: `/api/v1/reports/${report}/findings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all findings for a tenant.
   *
   * @tags Finding
   * @name ScanFindingList
   * @summary Get findings
   * @request GET:/api/v1/tenants/{tenant}/findings
   * @secure
   */
  scanFindingList = (
    tenant: string,
    query?: {
      /** Filter by source */
      source?: FindingSource;
    },
    params: RequestParams = {},
  ) =>
    this.request<FindingList, APIError>({
      path: `/api/v1/tenants/${tenant}/findings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a finding by id.
   *
   * @tags Finding
   * @name FindingGet
   * @summary Get finding
   * @request GET:/api/v1/findings/{finding}
   * @secure
   */
  findingGet = (
    finding: string,
    query?: {
      /**
       * The snapshot id (optional)
       * @format uuid
       * @minLength 36
       * @maxLength 36
       */
      snapshot?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Finding, APIError>({
      path: `/api/v1/findings/${finding}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a finding by id.
   *
   * @tags Finding
   * @name FindingUpdate
   * @summary Update finding
   * @request PATCH:/api/v1/findings/{finding}
   * @secure
   */
  findingUpdate = (finding: string, data: UpdateFindingRequest, params: RequestParams = {}) =>
    this.request<Finding, APIError>({
      path: `/api/v1/findings/${finding}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a finding by id.
   *
   * @tags Finding
   * @name FindingDelete
   * @summary Delete finding
   * @request DELETE:/api/v1/findings/{finding}
   * @secure
   */
  findingDelete = (finding: string, params: RequestParams = {}) =>
    this.request<Finding, APIError>({
      path: `/api/v1/findings/${finding}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Request remediation for a finding.
   *
   * @tags Finding
   * @name FindingUpdateRequestRemediation
   * @summary Request remediation
   * @request POST:/api/v1/findings/{finding}/request-remediation
   * @secure
   */
  findingUpdateRequestRemediation = (finding: string, data: RequestRemediationRequest, params: RequestParams = {}) =>
    this.request<Finding, APIError>({
      path: `/api/v1/findings/${finding}/request-remediation`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request remediation for a finding.
   *
   * @tags Finding
   * @name FindingUpdateCloseByAccepted
   * @summary Close the finding by accepting risk
   * @request POST:/api/v1/findings/{finding}/close-by-accepted
   * @secure
   */
  findingUpdateCloseByAccepted = (finding: string, data: CloseByAcceptedRequest, params: RequestParams = {}) =>
    this.request<Finding, APIError>({
      path: `/api/v1/findings/${finding}/close-by-accepted`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new image for a finding
   *
   * @tags Image
   * @name ImageCreate
   * @summary Create image
   * @request POST:/api/v1/reports/{report}/images
   * @secure
   */
  imageCreate = (
    report: string,
    data: {
      /** @format binary */
      img?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<CreateImageResponse, APIError>({
      path: `/api/v1/reports/${report}/images`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Get an image
   *
   * @tags Image
   * @name ImageGet
   * @summary Get image
   * @request GET:/api/v1/images/{image}
   * @secure
   */
  imageGet = (image: string, params: RequestParams = {}) =>
    this.request<any, void | APIError>({
      path: `/api/v1/images/${image}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description List all compliance frameworks.
   *
   * @tags ComplianceFramework
   * @name ComplianceFrameworkList
   * @summary Get compliance frameworks.
   * @request GET:/api/v1/compliance-frameworks
   * @secure
   */
  complianceFrameworkList = (
    query?: {
      /**
       * Optionally pass the tenant id to get estimated readiness for the compliance frameworks
       * @format uuid
       * @minLength 36
       * @maxLength 36
       */
      tenant?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ComplianceFrameworkList, APIError>({
      path: `/api/v1/compliance-frameworks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a compliance framework by id.
   *
   * @tags ComplianceFramework
   * @name ComplianceFrameworkGet
   * @summary Get compliance framework.
   * @request GET:/api/v1/compliance-frameworks/{compliance-framework}
   * @secure
   */
  complianceFrameworkGet = (complianceFramework: string, params: RequestParams = {}) =>
    this.request<ComplianceFramework, APIError>({
      path: `/api/v1/compliance-frameworks/${complianceFramework}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all requirements for a compliance framework.
   *
   * @tags ComplianceRequirement
   * @name ComplianceRequirementList
   * @summary Get compliance requirements for a compliance framework.
   * @request GET:/api/v1/compliance-frameworks/{compliance-framework}/requirements
   * @secure
   */
  complianceRequirementList = (complianceFramework: string, params: RequestParams = {}) =>
    this.request<ComplianceRequirementList, APIError>({
      path: `/api/v1/compliance-frameworks/${complianceFramework}/requirements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all of a tenant's tenant compliance frameworks
   *
   * @tags TenantComplianceFramework
   * @name TenantComplianceFrameworkList
   * @summary Get tenant compliance frameworks for a tenant.
   * @request GET:/api/v1/tenants/{tenant}/tenant-compliance-frameworks
   * @secure
   */
  tenantComplianceFrameworkList = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantComplianceFrameworkList, APIError>({
      path: `/api/v1/tenants/${tenant}/tenant-compliance-frameworks`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a tenant compliance framework.
   *
   * @tags TenantComplianceFramework
   * @name TenantComplianceFrameworkCreate
   * @summary Create a tenant compliance framework.
   * @request POST:/api/v1/tenants/{tenant}/tenant-compliance-frameworks
   * @secure
   */
  tenantComplianceFrameworkCreate = (
    tenant: string,
    data: CreateTenantComplianceFrameworkRequest,
    params: RequestParams = {},
  ) =>
    this.request<TenantComplianceFramework, APIError>({
      path: `/api/v1/tenants/${tenant}/tenant-compliance-frameworks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all of a tenant's tenant compliance framework for superadmins
   *
   * @tags TenantComplianceFramework
   * @name TenantComplianceFrameworkListAdmin
   * @summary Get tenant compliance frameworks for a tenant for superadmins.
   * @request GET:/api/v1/tenants/{tenant}/tenant-compliance-frameworks-admin
   * @secure
   */
  tenantComplianceFrameworkListAdmin = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantComplianceFrameworkList, APIError>({
      path: `/api/v1/tenants/${tenant}/tenant-compliance-frameworks-admin`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all tenant compliance frameworks with only information visible to employees
   *
   * @tags TenantComplianceFramework
   * @name TenantComplianceFrameworkListEmployee
   * @summary Get all tenant compliance frameworks with only information visible to employees
   * @request GET:/api/v1/tenants/{tenant}/tenant-compliance-frameworks-employee
   * @secure
   */
  tenantComplianceFrameworkListEmployee = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantComplianceFrameworkList, APIError>({
      path: `/api/v1/tenants/${tenant}/tenant-compliance-frameworks-employee`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all compliance program data for a tenant in a single optimized call (frameworks, requirements, and controls)
   *
   * @tags TenantComplianceFramework
   * @name TenantGetComplianceProgram
   * @summary Get compliance program data for a tenant (optimized).
   * @request GET:/api/v1/tenants/{tenant}/compliance-program
   * @secure
   */
  tenantGetComplianceProgram = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantComplianceProgramData, APIError>({
      path: `/api/v1/tenants/${tenant}/compliance-program`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a tenant compliance framework by id.
   *
   * @tags TenantComplianceFramework
   * @name TenantComplianceFrameworkGet
   * @summary Get a tenant compliance framework.
   * @request GET:/api/v1/tenant-compliance-frameworks/{tenant-compliance-framework}
   * @secure
   */
  tenantComplianceFrameworkGet = (tenantComplianceFramework: string, params: RequestParams = {}) =>
    this.request<TenantComplianceFramework, APIError>({
      path: `/api/v1/tenant-compliance-frameworks/${tenantComplianceFramework}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a tenant compliance framework by id.
   *
   * @tags TenantComplianceFramework
   * @name TenantComplianceFrameworkDelete
   * @summary Delete a tenant compliance framework.
   * @request DELETE:/api/v1/tenant-compliance-frameworks/{tenant-compliance-framework}
   * @secure
   */
  tenantComplianceFrameworkDelete = (tenantComplianceFramework: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenant-compliance-frameworks/${tenantComplianceFramework}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Update a tenant compliance framework by id.
   *
   * @tags TenantComplianceFramework
   * @name TenantComplianceFrameworkUpdate
   * @summary Update a tenant compliance framework.
   * @request PATCH:/api/v1/tenant-compliance-frameworks/{tenant-compliance-framework}
   * @secure
   */
  tenantComplianceFrameworkUpdate = (
    tenantComplianceFramework: string,
    data: UpdateTenantComplianceFrameworkRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/tenant-compliance-frameworks/${tenantComplianceFramework}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Generate an auditor dump and retrieve download url.
   *
   * @tags TenantComplianceFramework
   * @name TenantComplianceFrameworkCreateAuditorDump
   * @summary Generate an auditor dump and retrieve download url.
   * @request POST:/api/v1/tenant-compliance-frameworks/{tenant-compliance-framework}/auditor-dump
   * @secure
   */
  tenantComplianceFrameworkCreateAuditorDump = (tenantComplianceFramework: string, params: RequestParams = {}) =>
    this.request<
      {
        /** @format uri */
        downloadUrl?: string;
      },
      APIError
    >({
      path: `/api/v1/tenant-compliance-frameworks/${tenantComplianceFramework}/auditor-dump`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all tenant compliance requirements for a tenant framework.
   *
   * @tags TenantComplianceRequirement
   * @name TenantComplianceRequirementList
   * @summary Get requirements for a tenant framework.
   * @request GET:/api/v1/tenant-compliance-frameworks/{tenant-compliance-framework}/requirements
   * @secure
   */
  tenantComplianceRequirementList = (tenantComplianceFramework: string, params: RequestParams = {}) =>
    this.request<TenantComplianceRequirementList, APIError>({
      path: `/api/v1/tenant-compliance-frameworks/${tenantComplianceFramework}/requirements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a tenant compliance requirement by id.
   *
   * @name TenantComplianceRequirementGet
   * @summary Get a tenant compliance requirement.
   * @request GET:/api/v1/tenant-compliance-requirements/{tenant-compliance-requirement}
   * @secure
   */
  tenantComplianceRequirementGet = (tenantComplianceRequirement: string, params: RequestParams = {}) =>
    this.request<TenantComplianceRequirement, APIError>({
      path: `/api/v1/tenant-compliance-requirements/${tenantComplianceRequirement}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List integrations for a tenant
   *
   * @tags Integration
   * @name IntegrationList
   * @summary List integrations
   * @request GET:/api/v1/tenants/{tenant}/integrations
   * @secure
   */
  integrationList = (
    tenant: string,
    query?: {
      /** Include Oneleet managed integrations */
      includeOneleetManaged?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<IntegrationList, APIError>({
      path: `/api/v1/tenants/${tenant}/integrations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new integration for a tenant
   *
   * @tags Integration
   * @name IntegrationCreate
   * @summary Create new integration
   * @request POST:/api/v1/tenants/{tenant}/integrations
   * @secure
   */
  integrationCreate = (tenant: string, data: CreateIntegrationRequest, params: RequestParams = {}) =>
    this.request<Integration, APIError>({
      path: `/api/v1/tenants/${tenant}/integrations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get an integration by id
   *
   * @tags Integration
   * @name IntegrationGet
   * @summary Get integration
   * @request GET:/api/v1/integrations/{integration}
   * @secure
   */
  integrationGet = (integration: string, params: RequestParams = {}) =>
    this.request<Integration, APIError>({
      path: `/api/v1/integrations/${integration}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an integration by id
   *
   * @tags Integration
   * @name IntegrationUpdate
   * @summary Update integration
   * @request PATCH:/api/v1/integrations/{integration}
   * @secure
   */
  integrationUpdate = (integration: string, data: UpdateIntegrationRequest, params: RequestParams = {}) =>
    this.request<Integration, APIError>({
      path: `/api/v1/integrations/${integration}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an integration by id
   *
   * @tags Integration
   * @name IntegrationDelete
   * @summary Delete integration
   * @request DELETE:/api/v1/integrations/{integration}
   * @secure
   */
  integrationDelete = (integration: string, params: RequestParams = {}) =>
    this.request<Integration, APIError>({
      path: `/api/v1/integrations/${integration}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new integration connection
   *
   * @tags Integration
   * @name ConnectionCreate
   * @summary Create connection
   * @request POST:/api/v1/integrations/{integration}/connections
   * @secure
   */
  connectionCreate = (integration: string, data: CreateConnectionRequest, params: RequestParams = {}) =>
    this.request<Connection, APIError>({
      path: `/api/v1/integrations/${integration}/connections`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List monitors for an integration
   *
   * @tags Integration
   * @name IntegrationListMonitors
   * @summary List monitors
   * @request GET:/api/v1/integrations/{integration}/monitors
   * @secure
   */
  integrationListMonitors = (integration: string, params: RequestParams = {}) =>
    this.request<MonitorList, APIError>({
      path: `/api/v1/integrations/${integration}/monitors`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the data needed for the setup connection form for a new integration connection
   *
   * @tags Integration
   * @name IntegrationGetSetupData
   * @summary Get setup data
   * @request GET:/api/v1/integrations/{integration}/setup-data
   * @secure
   */
  integrationGetSetupData = (integration: string, params: RequestParams = {}) =>
    this.request<PreSetupConnectionResponse, APIError>({
      path: `/api/v1/integrations/${integration}/setup-data`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all available integration types
   *
   * @tags Integration
   * @name IntegrationListTypes
   * @summary List integration types
   * @request GET:/api/v1/integration-types
   * @secure
   */
  integrationListTypes = (params: RequestParams = {}) =>
    this.request<IntegrationTypeList, APIError>({
      path: `/api/v1/integration-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get an integration type by id
   *
   * @tags Integration
   * @name IntegrationGetType
   * @summary Get an integration type
   * @request GET:/api/v1/integration-types/{integration-type}
   * @secure
   */
  integrationGetType = (integrationType: string, params: RequestParams = {}) =>
    this.request<IntegrationType, APIError>({
      path: `/api/v1/integration-types/${integrationType}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List integration types for a tenant
   *
   * @tags Integration
   * @name IntegrationListTenantTypes
   * @summary List integration types
   * @request GET:/api/v1/tenants/{tenant}/integration-types
   * @secure
   */
  integrationListTenantTypes = (tenant: string, params: RequestParams = {}) =>
    this.request<IntegrationTypeList, APIError>({
      path: `/api/v1/tenants/${tenant}/integration-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List tenants for an integration type
   *
   * @tags Integration
   * @name IntegrationListTypeTenants
   * @summary List tenants for an integration type
   * @request GET:/api/v1/integration-types/{integration-type}/tenants
   * @secure
   */
  integrationListTypeTenants = (integrationType: string, params: RequestParams = {}) =>
    this.request<TenantList, APIError>({
      path: `/api/v1/integration-types/${integrationType}/tenants`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Notify tenants that use an integration type
   *
   * @tags Integration
   * @name IntegrationUpdateNotifyTypeTenants
   * @summary Notify tenants that use an integration type
   * @request POST:/api/v1/integration-types/{integration-type}/tenants/notifications
   * @secure
   */
  integrationUpdateNotifyTypeTenants = (
    integrationType: string,
    data: {
      /** The message to send to tenants (Markdown supported) */
      message: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/integration-types/${integrationType}/tenants/notifications`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description List asset types for an integration type
   *
   * @tags Integration
   * @name IntegrationListTypeAssetTypes
   * @summary List asset types for an integration type
   * @request GET:/api/v1/integration-types/{integration-type}/asset-types
   * @secure
   */
  integrationListTypeAssetTypes = (integrationType: string, params: RequestParams = {}) =>
    this.request<AssetTypeList, APIError>({
      path: `/api/v1/integration-types/${integrationType}/asset-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List monitor types for an integration type
   *
   * @tags Integration
   * @name IntegrationListTypeMonitorTypes
   * @summary List monitor types for an integration type
   * @request GET:/api/v1/integration-types/{integration-type}/monitor-types
   * @secure
   */
  integrationListTypeMonitorTypes = (integrationType: string, params: RequestParams = {}) =>
    this.request<MonitorTypeList, APIError>({
      path: `/api/v1/integration-types/${integrationType}/monitor-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Install the Oneleet GitHub app
   *
   * @tags Integration
   * @name IntegrationUpdateGithubAppInstall
   * @summary Handle GitHub app installation
   * @request GET:/api/v1/integrations/{integration}/github-app-install/{app}
   * @secure
   */
  integrationUpdateGithubAppInstall = (
    integration: string,
    app: "app",
    query?: {
      /** Origin of the request */
      origin?: "CODE_SECURITY" | "INTEGRATIONS";
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void | APIError>({
      path: `/api/v1/integrations/${integration}/github-app-install/${app}`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Receive webhook events for the Oneleet GitHub App
   *
   * @tags Integration
   * @name GithubWebhookCreate
   * @summary Handle GitHub App webhook
   * @request POST:/api/v1/integrations/github-app-webhook
   */
  githubWebhookCreate = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/v1/integrations/github-app-webhook`,
      method: "POST",
      ...params,
    });
  /**
   * @description Callback after installing the Oneleet GitHub app
   *
   * @tags Integration
   * @name IntegrationUpdateGithubAppCallback
   * @summary Handle GitHub app installation
   * @request GET:/api/v1/integrations/github-app-callback/{app}
   * @secure
   */
  integrationUpdateGithubAppCallback = (app: "app", params: RequestParams = {}) =>
    this.request<any, void | APIError>({
      path: `/api/v1/integrations/github-app-callback/${app}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Start the oauth flow for an integration
   *
   * @tags Integration
   * @name IntegrationUpdateOauthStart
   * @summary Start oauth flow
   * @request GET:/api/v1/integrations/{integration}/oauth-start/{app}
   * @secure
   */
  integrationUpdateOauthStart = (
    integration: string,
    app: "app",
    query?: {
      /** Existing connection id */
      connectionId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void | APIError>({
      path: `/api/v1/integrations/${integration}/oauth-start/${app}`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Handle the oauth callback flow for an integration
   *
   * @tags Integration
   * @name IntegrationUpdateOauthCallback
   * @summary Handle oauth callback
   * @request GET:/api/v1/integrations/oauth/{oauth-app-name}/callback/{app}
   * @secure
   */
  integrationUpdateOauthCallback = (oauthAppName: string, app: "app", params: RequestParams = {}) =>
    this.request<any, void | APIError>({
      path: `/api/v1/integrations/oauth/${oauthAppName}/callback/${app}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Get a session token to initiate Nango auth flow
   *
   * @tags Integration
   * @name IntegrationGetNangoSessionToken
   * @summary Get Nango session token
   * @request POST:/api/v1/integrations/{integration}/nango-session-token
   * @secure
   */
  integrationGetNangoSessionToken = (integration: string, params: RequestParams = {}) =>
    this.request<NangoAuthSessionTokenResponse, APIError>({
      path: `/api/v1/integrations/${integration}/nango-session-token`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Handle webhook callbacks from Nango
   *
   * @tags Integration
   * @name IntegrationUpdateNangoCallback
   * @summary Handle Nango callbacks
   * @request POST:/api/v1/integrations/nango-callback
   */
  integrationUpdateNangoCallback = (data: NangoAuthCallbackRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/integrations/nango-callback`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Get the external ID for a new AWS integration connection
   *
   * @tags Integration
   * @name IntegrationGetAwsExternalId
   * @summary Fetch external ID for AWS connection
   * @request GET:/api/v1/integrations/{integration}/aws-external-id
   * @secure
   */
  integrationGetAwsExternalId = (integration: string, params: RequestParams = {}) =>
    this.request<AWSExternalId, APIError>({
      path: `/api/v1/integrations/${integration}/aws-external-id`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generates a CloudFormation template, puts it in an S3 bucket, and creates a stack quick-create link for a new AWS v2 integration connection
   *
   * @tags Integration
   * @name IntegrationCreateAwsTemplateUrl
   * @summary Fetch external ID for AWS connection
   * @request POST:/api/v1/integrations/{integration}/aws-template
   * @secure
   */
  integrationCreateAwsTemplateUrl = (integration: string, data: AWSTemplateUrlRequest, params: RequestParams = {}) =>
    this.request<AWSTemplateUrlResponse, APIError>({
      path: `/api/v1/integrations/${integration}/aws-template`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Inspect data accessible through a client integration for debugging purposes
   *
   * @tags Integration
   * @name IntegrationGetInspect
   * @summary Inspect integration responses for production debugging
   * @request POST:/api/v1/integrations/{integration}/connections/{connection}/inspector
   * @secure
   */
  integrationGetInspect = (
    integration: string,
    connection: string,
    data: IntegrationInspectorRequest,
    params: RequestParams = {},
  ) =>
    this.request<IntegrationInspectorResponse, APIError>({
      path: `/api/v1/integrations/${integration}/connections/${connection}/inspector`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Reconnect an integration's connection
   *
   * @tags Integration
   * @name ConnectionUpdateReconnect
   * @summary Reconnect the connection
   * @request PUT:/api/v1/connections/{connection}
   * @secure
   */
  connectionUpdateReconnect = (connection: string, data: ReconnectConnectionRequest, params: RequestParams = {}) =>
    this.request<Connection, APIError>({
      path: `/api/v1/connections/${connection}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update an integration connection configuration
   *
   * @tags Integration
   * @name ConnectionUpdateConfiguration
   * @summary Update connection configuration
   * @request PATCH:/api/v1/connections/{connection}
   * @secure
   */
  connectionUpdateConfiguration = (
    connection: string,
    data: UpdateConnectionConfigurationRequest,
    params: RequestParams = {},
  ) =>
    this.request<Connection, APIError>({
      path: `/api/v1/connections/${connection}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an integration connection
   *
   * @tags Integration
   * @name ConnectionDelete
   * @summary Create connection
   * @request DELETE:/api/v1/connections/{connection}
   * @secure
   */
  connectionDelete = (connection: string, params: RequestParams = {}) =>
    this.request<Connection, APIError>({
      path: `/api/v1/connections/${connection}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an asset
   *
   * @tags Asset
   * @name AssetUpdate
   * @summary Update asset
   * @request PATCH:/api/v1/assets/{asset}
   * @secure
   */
  assetUpdate = (asset: string, data: UpdateAssetRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/assets/${asset}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description List all assets that belong to an integration
   *
   * @name AssetTypeList
   * @summary List asset types with their assets for an integration
   * @request GET:/api/v1/integrations/{integration}/assets
   * @secure
   */
  assetTypeList = (integration: string, params: RequestParams = {}) =>
    this.request<AssetTypeList, APIError>({
      path: `/api/v1/integrations/${integration}/assets`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Ignore an asset for all monitors
   *
   * @name AssetUpdateIgnoreGlobally
   * @summary Ignore an asset for all existing monitors
   * @request POST:/api/v1/assets/{asset}/ignore-globally
   * @secure
   */
  assetUpdateIgnoreGlobally = (asset: string, data: IgnoreAssetGlobally, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/assets/${asset}/ignore-globally`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Gets a list of a tenant's domains.
   *
   * @tags Domain
   * @name DomainList
   * @summary Get domains
   * @request GET:/api/v1/tenants/{tenant}/domains
   * @secure
   */
  domainList = (tenant: string, params: RequestParams = {}) =>
    this.request<DomainList, APIError>({
      path: `/api/v1/tenants/${tenant}/domains`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a domain.
   *
   * @tags Domain
   * @name DomainCreate
   * @summary Create domain
   * @request POST:/api/v1/tenants/{tenant}/domains
   * @secure
   */
  domainCreate = (tenant: string, data: CreateDomainRequest, params: RequestParams = {}) =>
    this.request<Domain, APIError>({
      path: `/api/v1/tenants/${tenant}/domains`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a list of a tenant's subdomains.
   *
   * @tags Subdomain
   * @name SubdomainList
   * @summary Get subdomains
   * @request GET:/api/v1/tenants/{tenant}/subdomains
   * @secure
   */
  subdomainList = (tenant: string, params: RequestParams = {}) =>
    this.request<SubdomainList, APIError>({
      path: `/api/v1/tenants/${tenant}/subdomains`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a domain.
   *
   * @tags Domain
   * @name DomainDelete
   * @summary Delete domain
   * @request DELETE:/api/v1/domains/{domain}
   * @secure
   */
  domainDelete = (domain: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/domains/${domain}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Verifies a domain.
   *
   * @tags Domain
   * @name DomainUpdateVerify
   * @summary Verify domain
   * @request POST:/api/v1/domains/{domain}/verify
   * @secure
   */
  domainUpdateVerify = (domain: string, params: RequestParams = {}) =>
    this.request<Domain, APIError>({
      path: `/api/v1/domains/${domain}/verify`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create an ingress hostname for the domain.
   *
   * @name DomainUpdateIngressHostname
   * @summary Create a hostname in the ingress hostnames.
   * @request POST:/api/v1/tenants/{domain}/ingress-hostname
   * @secure
   */
  domainUpdateIngressHostname = (domain: string, data: CreateIngressHostnameRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${domain}/ingress-hostname`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Delete the ingress hostname for a domain.
   *
   * @name DomainDeleteIngressHostname
   * @summary Delete the ingress hostname for a domain.
   * @request DELETE:/api/v1/tenants/{domain}/ingress-hostname
   * @secure
   */
  domainDeleteIngressHostname = (domain: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${domain}/ingress-hostname`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List control types.
   *
   * @tags ControlType
   * @name ControlTypeList
   * @summary List control types.
   * @request GET:/api/v1/control-types
   * @secure
   */
  controlTypeList = (params: RequestParams = {}) =>
    this.request<ControlTypeList, APIError>({
      path: `/api/v1/control-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List controls for a tenant.
   *
   * @tags Control
   * @name ControlList
   * @summary List controls for a tenant.
   * @request GET:/api/v1/tenants/{tenant}/controls
   * @secure
   */
  controlList = (tenant: string, params: RequestParams = {}) =>
    this.request<ControlList, APIError>({
      path: `/api/v1/tenants/${tenant}/controls`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new control.
   *
   * @tags Control
   * @name ControlCreate
   * @summary Create a new control.
   * @request POST:/api/v1/tenants/{tenant}/controls
   * @secure
   */
  controlCreate = (tenant: string, data: CreateControlRequest, params: RequestParams = {}) =>
    this.request<Control, APIError>({
      path: `/api/v1/tenants/${tenant}/controls`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List controls for a tenant compliance framework.
   *
   * @tags Control
   * @name ControlListTenantComplianceFramework
   * @summary List controls for a tenant compliance framework.
   * @request GET:/api/v1/tenant-compliance-framework/{tenant-compliance-framework}/controls
   * @secure
   */
  controlListTenantComplianceFramework = (tenantComplianceFramework: string, params: RequestParams = {}) =>
    this.request<ControlList, APIError>({
      path: `/api/v1/tenant-compliance-framework/${tenantComplianceFramework}/controls`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List controls for a tenant compliance requirement.
   *
   * @tags Control
   * @name ControlListTenantComplianceRequirement
   * @summary List controls for a tenant compliance requirement.
   * @request GET:/api/v1/tenant-compliance-requirements/{tenant-compliance-requirement}/controls
   * @secure
   */
  controlListTenantComplianceRequirement = (tenantComplianceRequirement: string, params: RequestParams = {}) =>
    this.request<ControlList, APIError>({
      path: `/api/v1/tenant-compliance-requirements/${tenantComplianceRequirement}/controls`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a control by id.
   *
   * @tags Control
   * @name ControlGet
   * @summary Get a control by id.
   * @request GET:/api/v1/controls/{control}
   * @secure
   */
  controlGet = (control: string, params: RequestParams = {}) =>
    this.request<Control, APIError>({
      path: `/api/v1/controls/${control}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a control by id.
   *
   * @tags Control
   * @name ControlDelete
   * @summary Delete a control by id.
   * @request DELETE:/api/v1/controls/{control}
   * @secure
   */
  controlDelete = (control: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/controls/${control}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Add a new comment to a control.
   *
   * @tags Control
   * @name ControlUpdateAddComment
   * @summary Add a new comment to a control.
   * @request POST:/api/v1/controls/{control}/comments
   * @secure
   */
  controlUpdateAddComment = (control: string, data: UpdateControlCommentRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/controls/${control}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Update a comment on a control.
   *
   * @tags Control
   * @name ControlUpdateComment
   * @summary Update a comment on a control.
   * @request PATCH:/api/v1/controls/{control}/comments/{comment}
   * @secure
   */
  controlUpdateComment = (
    control: string,
    comment: string,
    data: UpdateControlCommentRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/controls/${control}/comments/${comment}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Delete a comment on a control.
   *
   * @tags Control
   * @name ControlDeleteComment
   * @summary Delete a comment on a control.
   * @request DELETE:/api/v1/controls/{control}/comments/{comment}
   * @secure
   */
  controlDeleteComment = (control: string, comment: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/controls/${control}/comments/${comment}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List activities for a control.
   *
   * @tags Control
   * @name ControlGetActivities
   * @summary List activities for a control.
   * @request GET:/api/v1/controls/{control}/activities
   * @secure
   */
  controlGetActivities = (control: string, params: RequestParams = {}) =>
    this.request<ActivityList, APIError>({
      path: `/api/v1/controls/${control}/activities`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Request a review for a control.
   *
   * @tags Control
   * @name ControlUpdateRequestReview
   * @summary Request a review for a control.
   * @request POST:/api/v1/controls/{control}/request-review
   * @secure
   */
  controlUpdateRequestReview = (control: string, params: RequestParams = {}) =>
    this.request<Control, APIError>({
      path: `/api/v1/controls/${control}/request-review`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel a review request for a control.
   *
   * @tags Control
   * @name ControlUpdateCancelReviewRequest
   * @summary Cancel a review request for a control.
   * @request POST:/api/v1/controls/{control}/cancel-review-request
   * @secure
   */
  controlUpdateCancelReviewRequest = (control: string, params: RequestParams = {}) =>
    this.request<Control, APIError>({
      path: `/api/v1/controls/${control}/cancel-review-request`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the assigned member for the control
   *
   * @tags Control
   * @name ControlUpdateAssignedMember
   * @summary Update the assigned member for the control
   * @request PATCH:/api/v1/controls/{control}/assigned-member
   * @secure
   */
  controlUpdateAssignedMember = (
    control: string,
    data: ControlUpdateAssignedMemberRequest,
    params: RequestParams = {},
  ) =>
    this.request<Control, APIError>({
      path: `/api/v1/controls/${control}/assigned-member`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a review for a control.
   *
   * @tags Control
   * @name ControlUpdateSubmitReview
   * @summary Submit a review for a control.
   * @request POST:/api/v1/controls/submit-reviews
   * @secure
   */
  controlUpdateSubmitReview = (data: SubmitControlReviewRequests, params: RequestParams = {}) =>
    this.request<Control[], APIError>({
      path: `/api/v1/controls/submit-reviews`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List control reviews for all tenants.
   *
   * @tags Control
   * @name ControlListReviews
   * @summary List control reviews for all tenants.
   * @request GET:/api/v1/controls/reviews
   * @secure
   */
  controlListReviews = (
    query?: {
      /**
       * Whether to include completed reviews in the response
       * @default false
       */
      showCompleted?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<ControlList, APIError>({
      path: `/api/v1/controls/reviews`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List checks for a control.
   *
   * @tags Control
   * @name CheckList
   * @summary List control checks.
   * @request GET:/api/v1/controls/{control}/checks
   * @secure
   */
  checkList = (control: string, params: RequestParams = {}) =>
    this.request<CheckList, APIError>({
      path: `/api/v1/controls/${control}/checks`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the assigned reviewer for the control
   *
   * @tags Control
   * @name ControlUpdateAssignedReviewer
   * @summary Update the assigned reviewer for the control
   * @request PATCH:/api/v1/controls/{control}/assigned-reviewer
   * @secure
   */
  controlUpdateAssignedReviewer = (
    control: string,
    data: ControlUpdateAssignedReviewerRequest,
    params: RequestParams = {},
  ) =>
    this.request<Control, APIError>({
      path: `/api/v1/controls/${control}/assigned-reviewer`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update control content including title, description, and instructions.
   *
   * @tags Control
   * @name ControlUpdateContent
   * @summary Update control content.
   * @request PATCH:/api/v1/controls/{control}/update-content
   * @secure
   */
  controlUpdateContent = (control: string, data: UpdateControlContentRequest, params: RequestParams = {}) =>
    this.request<Control, APIError>({
      path: `/api/v1/controls/${control}/update-content`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List the evidence under a tenant.
   *
   * @tags Evidence
   * @name EvidenceList
   * @summary List the evidence under a tenant.
   * @request GET:/api/v1/tenants/{tenant}/evidence
   * @secure
   */
  evidenceList = (tenant: string, params: RequestParams = {}) =>
    this.request<Evidence[], APIError>({
      path: `/api/v1/tenants/${tenant}/evidence`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new evidence for a tenant and optionally a control.
   *
   * @tags Evidence
   * @name EvidenceCreate
   * @summary Create a new evidence for a tenant and optionally a control.
   * @request POST:/api/v1/tenants/{tenant}/evidence
   * @secure
   */
  evidenceCreate = (tenant: string, data: CreateEvidenceRequest, params: RequestParams = {}) =>
    this.request<Evidence, APIError>({
      path: `/api/v1/tenants/${tenant}/evidence`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Update an evidence by id.
   *
   * @tags Evidence
   * @name EvidenceUpdate
   * @summary Update an evidence by id.
   * @request PATCH:/api/v1/evidence/{evidence}
   * @secure
   */
  evidenceUpdate = (evidence: string, data: UpdateEvidenceRequest, params: RequestParams = {}) =>
    this.request<Evidence, APIError>({
      path: `/api/v1/evidence/${evidence}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an evidence by id.
   *
   * @tags Evidence
   * @name EvidenceDelete
   * @summary Delete an evidence by id.
   * @request DELETE:/api/v1/evidence/{evidence}
   * @secure
   */
  evidenceDelete = (evidence: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/evidence/${evidence}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Link an evidence to a control and optionally an evidence request.
   *
   * @tags Evidence
   * @name EvidenceUpdateLink
   * @summary Link an evidence to a control and optionally an evidence request.
   * @request POST:/api/v1/evidence/{evidence}/link
   * @secure
   */
  evidenceUpdateLink = (evidence: string, data: LinkEvidenceRequest, params: RequestParams = {}) =>
    this.request<Evidence, APIError>({
      path: `/api/v1/evidence/${evidence}/link`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Unlinks an evidence from a control
   *
   * @tags Evidence
   * @name EvidenceUpdateUnlink
   * @summary Unlink an evidence from a control
   * @request POST:/api/v1/evidence/{evidence}/unlink
   * @secure
   */
  evidenceUpdateUnlink = (evidence: string, data: UnlinkEvidenceRequest, params: RequestParams = {}) =>
    this.request<Evidence, APIError>({
      path: `/api/v1/evidence/${evidence}/unlink`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new evidence request.
   *
   * @tags EvidenceRequest
   * @name EvidenceRequestCreate
   * @summary Create a new evidence request.
   * @request POST:/api/v1/controls/{control}/evidence-request
   * @secure
   */
  evidenceRequestCreate = (control: string, data: CreateEvidenceRequestRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/controls/${control}/evidence-request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Update an evidence request by id.
   *
   * @tags EvidenceRequest
   * @name EvidenceRequestUpdate
   * @summary Update an evidence request by id.
   * @request POST:/api/v1/evidence-request/{evidence-request}
   * @secure
   */
  evidenceRequestUpdate = (evidenceRequest: string, data: UpdateEvidenceRequestRequest, params: RequestParams = {}) =>
    this.request<EvidenceRequest, APIError>({
      path: `/api/v1/evidence-request/${evidenceRequest}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an evidence request by id.
   *
   * @tags EvidenceRequest
   * @name EvidenceRequestDelete
   * @summary Delete an evidence request by id.
   * @request DELETE:/api/v1/evidence-request/{evidence-request}
   * @secure
   */
  evidenceRequestDelete = (evidenceRequest: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/evidence-request/${evidenceRequest}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Link an evidence to a vendor.
   *
   * @tags Evidence
   * @name EvidenceUpdateLinkToVendor
   * @summary Link an evidence to a vendor.
   * @request POST:/api/v1/evidence/{evidence}/link-to-vendor
   * @secure
   */
  evidenceUpdateLinkToVendor = (evidence: string, data: LinkEvidenceToVendorRequest, params: RequestParams = {}) =>
    this.request<Evidence, APIError>({
      path: `/api/v1/evidence/${evidence}/link-to-vendor`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Unlink an evidence from a vendor.
   *
   * @tags Evidence
   * @name EvidenceUpdateUnlinkFromVendor
   * @summary Unlink an evidence from a vendor.
   * @request POST:/api/v1/evidence/{evidence}/unlink-from-vendor
   * @secure
   */
  evidenceUpdateUnlinkFromVendor = (
    evidence: string,
    data: UnlinkEvidenceFromVendorRequest,
    params: RequestParams = {},
  ) =>
    this.request<Evidence, APIError>({
      path: `/api/v1/evidence/${evidence}/unlink-from-vendor`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List monitors for a tenant
   *
   * @name MonitorList
   * @summary List monitors for a tenant
   * @request GET:/api/v1/tenants/{tenant}/monitors
   * @secure
   */
  monitorList = (
    tenant: string,
    query?: {
      /** The asset type ID to filter monitors on */
      assetTypeId?: string;
      /** A boolean indicating if we only want monitors which are enabled or disabled. Omit for both. */
      isEnabled?: boolean;
      /**
       * A date after which only monitors with a reviewRemindAt value greater than and not null will be returned
       * @format date-time
       */
      reviewRemindAfter?: string;
      /**
       * A date before which only monitors with a reviewRemindAt value less than and not null will be returned
       * @format date-time
       */
      reviewRemindBefore?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<MonitorList, APIError>({
      path: `/api/v1/tenants/${tenant}/monitors`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a monitor
   *
   * @tags Monitors
   * @name MonitorGet
   * @summary Get a monitor
   * @request GET:/api/v1/monitors/{monitor}
   * @secure
   */
  monitorGet = (monitor: string, params: RequestParams = {}) =>
    this.request<Monitor, APIError>({
      path: `/api/v1/monitors/${monitor}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Rerun a monitor
   *
   * @tags Monitors
   * @name MonitorUpdateRerun
   * @summary Rerun a monitor
   * @request POST:/api/v1/monitors/{monitor}/rerun
   * @secure
   */
  monitorUpdateRerun = (monitor: string, params: RequestParams = {}) =>
    this.request<Monitor, APIError>({
      path: `/api/v1/monitors/${monitor}/rerun`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the monitor to be enabled or disabled
   *
   * @name MonitorUpdateEnabled
   * @summary Update the enabled status of a monitor
   * @request POST:/api/v1/monitors/{monitor}/enabled
   * @secure
   */
  monitorUpdateEnabled = (monitor: string, data: MonitorUpdateEnabled, params: RequestParams = {}) =>
    this.request<Monitor, APIError>({
      path: `/api/v1/monitors/${monitor}/enabled`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update the monitor configuration options, if any
   *
   * @name MonitorUpdateConfig
   * @summary Update the configuration options of a monitor
   * @request PATCH:/api/v1/monitors/{monitor}/config
   * @secure
   */
  monitorUpdateConfig = (monitor: string, data: MonitorUpdateConfig, params: RequestParams = {}) =>
    this.request<Monitor, APIError>({
      path: `/api/v1/monitors/${monitor}/config`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get the latest asset result snapshots for a monitor
   *
   * @tags Monitors
   * @name MonitorResultSnapshotList
   * @summary Get the latest asset results for a monitor
   * @request GET:/api/v1/monitors/{monitor}/asset-result-snapshots/latest
   * @secure
   */
  monitorResultSnapshotList = (monitor: string, params: RequestParams = {}) =>
    this.request<ResultSnapshotList, APIError>({
      path: `/api/v1/monitors/${monitor}/asset-result-snapshots/latest`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List monitor states
   *
   * @tags Monitors
   * @name MonitorStateList
   * @summary List monitor states
   * @request GET:/api/v1/monitors/{monitor}/states
   * @secure
   */
  monitorStateList = (monitor: string, params: RequestParams = {}) =>
    this.request<MonitorStateList, APIError>({
      path: `/api/v1/monitors/${monitor}/states`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List recent monitor runs
   *
   * @tags Monitors
   * @name MonitorGetRuns
   * @summary List recent monitor runs
   * @request GET:/api/v1/monitors/{monitor}/runs
   * @secure
   */
  monitorGetRuns = (monitor: string, params: RequestParams = {}) =>
    this.request<MonitorRunList, APIError>({
      path: `/api/v1/monitors/${monitor}/runs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update ignore status for assets
   *
   * @name MonitorUpdateIgnoreStatusForAssets
   * @summary Update ignore status for assets
   * @request POST:/api/v1/monitors/{monitor}/update-assets-ignore-status
   * @secure
   */
  monitorUpdateIgnoreStatusForAssets = (
    monitor: string,
    data: MonitorUpdateIgnoreStatusForAssets,
    params: RequestParams = {},
  ) =>
    this.request<Monitor, APIError>({
      path: `/api/v1/monitors/${monitor}/update-assets-ignore-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all controls for a monitor
   *
   * @name MonitorGetControls
   * @summary List all controls for a monitor
   * @request GET:/api/v1/monitors/{monitor}/controls
   * @secure
   */
  monitorGetControls = (monitor: string, params: RequestParams = {}) =>
    this.request<ControlList, APIError>({
      path: `/api/v1/monitors/${monitor}/controls`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all feature flags available
   *
   * @name FeatureFlagList
   * @summary Get tenant feature flags
   * @request GET:/api/v1/feature-flags
   * @secure
   */
  featureFlagList = (params: RequestParams = {}) =>
    this.request<FeatureFlagList, APIError>({
      path: `/api/v1/feature-flags`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all in-app documents for a tenant
   *
   * @tags Documents
   * @name DocumentList
   * @summary List all in-app documents
   * @request GET:/api/v1/tenants/{tenant}/documents
   * @secure
   */
  documentList = (
    tenant: string,
    query?: {
      /**
       * The template id
       * @maxLength 50
       */
      templateId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<InAppDocumentList, APIError>({
      path: `/api/v1/tenants/${tenant}/documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create an in-app document
   *
   * @tags Documents
   * @name DocumentCreate
   * @summary Create an in-app document
   * @request POST:/api/v1/tenants/{tenant}/documents
   * @secure
   */
  documentCreate = (tenant: string, data: CreateInAppDocumentRequest, params: RequestParams = {}) =>
    this.request<InAppDocument, APIError>({
      path: `/api/v1/tenants/${tenant}/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get an in-app document
   *
   * @tags Documents
   * @name DocumentGet
   * @summary Get an in-app document
   * @request GET:/api/v1/documents/{document}
   * @secure
   */
  documentGet = (document: string, params: RequestParams = {}) =>
    this.request<InAppDocument, APIError>({
      path: `/api/v1/documents/${document}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an in-app document
   *
   * @tags Documents
   * @name DocumentUpdate
   * @summary Update an in-app document
   * @request POST:/api/v1/documents/{document}
   * @secure
   */
  documentUpdate = (document: string, data: UpdateInAppDocumentRequest, params: RequestParams = {}) =>
    this.request<InAppDocument, APIError>({
      path: `/api/v1/documents/${document}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an in-app document
   *
   * @tags Documents
   * @name DocumentDelete
   * @summary Delete an in-app document
   * @request DELETE:/api/v1/documents/{document}
   * @secure
   */
  documentDelete = (document: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/documents/${document}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Get all in-app documents templates for a tenant
   *
   * @tags Documents
   * @name DocumentTemplateList
   * @summary List all in-app documents
   * @request GET:/api/v1/tenants/{tenant}/document-templates
   * @secure
   */
  documentTemplateList = (tenant: string, params: RequestParams = {}) =>
    this.request<InAppDocumentTemplateList, APIError>({
      path: `/api/v1/tenants/${tenant}/document-templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get an in-app document template
   *
   * @tags Documents
   * @name DocumentTemplateGet
   * @summary Get an in-app document template
   * @request GET:/api/v1/document-templates/{document-template}
   * @secure
   */
  documentTemplateGet = (documentTemplate: string, params: RequestParams = {}) =>
    this.request<InAppDocumentTemplate, APIError>({
      path: `/api/v1/document-templates/${documentTemplate}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List tenant-scoped workflows
   *
   * @tags Workflow
   * @name WorkflowList
   * @summary List workflows
   * @request GET:/api/v1/tenants/{tenant}/workflows
   * @secure
   */
  workflowList = (
    tenant: string,
    query?: {
      /** The type of workflows to filter by */
      type?: WorkflowType;
    },
    params: RequestParams = {},
  ) =>
    this.request<WorkflowList, APIError>({
      path: `/api/v1/tenants/${tenant}/workflows`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Receive webhook events for the Oneleet Slack App
   *
   * @tags Slack
   * @name SlackCreateEvent
   * @summary Handle Slack App events
   * @request POST:/api/v1/slack-events
   */
  slackCreateEvent = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/v1/slack-events`,
      method: "POST",
      ...params,
    });
  /**
   * @description Get tenant Slack settings
   *
   * @tags Slack
   * @name TenantGetSlackSettings
   * @summary Get Slack settings
   * @request GET:/api/v1/tenants/{tenant}/slack
   * @secure
   */
  tenantGetSlackSettings = (tenant: string, params: RequestParams = {}) =>
    this.request<SlackSettings, APIError | void>({
      path: `/api/v1/tenants/${tenant}/slack`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Connect slack to a tenant
   *
   * @tags Slack
   * @name TenantUpdateSlackSettings
   * @summary Connect slack
   * @request POST:/api/v1/tenants/{tenant}/slack
   * @secure
   */
  tenantUpdateSlackSettings = (tenant: string, data: UpdateSlackSettingsRequest, params: RequestParams = {}) =>
    this.request<SlackSettings, APIError>({
      path: `/api/v1/tenants/${tenant}/slack`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all Slack channels
   *
   * @tags Slack
   * @name TenantGetSlackChannels
   * @summary List channels
   * @request GET:/api/v1/tenants/{tenant}/slack/channels
   * @secure
   */
  tenantGetSlackChannels = (tenant: string, params: RequestParams = {}) =>
    this.request<SlackChannelList, APIError>({
      path: `/api/v1/tenants/${tenant}/slack/channels`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List tenant-scoped tasks
   *
   * @tags Workflow
   * @name TaskList
   * @summary List workflows
   * @request GET:/api/v1/tenants/{tenant}/tasks
   * @secure
   */
  taskList = (tenant: string, params: RequestParams = {}) =>
    this.request<TaskList, APIError>({
      path: `/api/v1/tenants/${tenant}/tasks`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a task by id
   *
   * @name TaskGet
   * @summary Get a task by id
   * @request GET:/api/v1/tasks/{task}
   * @secure
   */
  taskGet = (task: string, params: RequestParams = {}) =>
    this.request<Task, APIError>({
      path: `/api/v1/tasks/${task}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List exceptions for tenant.
   *
   * @tags TenantExceptions
   * @name ExceptionList
   * @summary List exceptions.
   * @request GET:/api/v1/tenants/{tenant}/exceptions
   * @secure
   */
  exceptionList = (
    tenant: string,
    query?: {
      /**
       * The id of the tenant compliance framework
       * @format uuid
       * @minLength 36
       * @maxLength 36
       */
      tenantComplianceFrameworkId?: string;
      /**
       * The id of the control
       * @format uuid
       * @minLength 36
       * @maxLength 36
       */
      controlId?: string;
      /**
       * The start of the date range
       * @format date-time
       */
      startDate?: string;
      /**
       * The end of the date range
       * @format date-time
       */
      endDate?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ExceptionList, APIError>({
      path: `/api/v1/tenants/${tenant}/exceptions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an exception by id.
   *
   * @name ExceptionUpdateVisibility
   * @summary exception:update:visibility
   * @request PUT:/api/v1/exceptions/{exception}
   * @secure
   */
  exceptionUpdateVisibility = (exception: string, data: UpdateExceptionVisibility, params: RequestParams = {}) =>
    this.request<Exception, APIError>({
      path: `/api/v1/exceptions/${exception}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update an exception by id.
   *
   * @tags TenantExceptions
   * @name ExceptionUpdateNotes
   * @summary Update an exception.
   * @request PATCH:/api/v1/exceptions/{exception}
   * @secure
   */
  exceptionUpdateNotes = (exception: string, data: UpdateExceptionNotes, params: RequestParams = {}) =>
    this.request<Exception, APIError>({
      path: `/api/v1/exceptions/${exception}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Issue a command to an Apple MDM device (e.g. lock, wipe, etc.)
   *
   * @tags Device
   * @name TenantDeviceUpdateAppleMdmCommand
   * @summary Issue a command to an Apple MDM device
   * @request POST:/api/v1/tenant-devices/{tenant-device}/apple-mdm/command
   * @secure
   */
  tenantDeviceUpdateAppleMdmCommand = (
    tenantDevice: string,
    data: AppleMDMCommandRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/tenant-devices/${tenantDevice}/apple-mdm/command`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Pre-enrolls an Agent device and gets a pre-enrollment token
   *
   * @name PreEnrollDeviceCreate
   * @summary Pre-enroll an Agent device
   * @request POST:/api/v1/agent/pre-enroll
   */
  preEnrollDeviceCreate = (data: PreEnrollAgentDeviceRequest, params: RequestParams = {}) =>
    this.request<PreEnrollAgentDeviceResponse, APIError>({
      path: `/api/v1/agent/pre-enroll`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Logs in an Agent device and gets a token
   *
   * @name AgentLoginCreate
   * @summary Login an Agent device
   * @request POST:/api/v1/agent/login
   */
  agentLoginCreate = (data: DeviceLoginRequest, params: RequestParams = {}) =>
    this.request<DeviceLoginResponse, APIError>({
      path: `/api/v1/agent/login`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Logs out the MDM device
   *
   * @name AgentLogoutCreate
   * @summary Logout MDM device
   * @request POST:/api/v1/agent/logout
   * @secure
   */
  agentLogoutCreate = (params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/agent/logout`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Check the enrollment status of the Agent device
   *
   * @name AgentDeviceStatusGet
   * @summary Check Agent device enrollment status
   * @request GET:/api/v1/agent/status
   * @secure
   */
  agentDeviceStatusGet = (params: RequestParams = {}) =>
    this.request<AgentDeviceStatusResponse, APIError>({
      path: `/api/v1/agent/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a device's Agent data
   *
   * @name AgentDeviceDataGet
   * @summary Get a device's information
   * @request GET:/api/v1/agent/data
   * @secure
   */
  agentDeviceDataGet = (params: RequestParams = {}) =>
    this.request<AgentDeviceDataResponse, APIError>({
      path: `/api/v1/agent/data`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a device's Agent data
   *
   * @name AgentDeviceDataUpdate
   * @summary Update a device's information
   * @request PATCH:/api/v1/agent/data
   * @secure
   */
  agentDeviceDataUpdate = (data: AgentDeviceUpdateRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/agent/data`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description List git repositories for a tenant
   *
   * @name GitRepositoryList
   * @summary List git repositories for a tenant
   * @request GET:/api/v1/tenants/{tenant}/git-repository
   * @secure
   */
  gitRepositoryList = (tenant: string, params: RequestParams = {}) =>
    this.request<GitRepositoryList, APIError>({
      path: `/api/v1/tenants/${tenant}/git-repository`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a Git Repository for a tenant
   *
   * @name GitRepositoryCreate
   * @summary Create Git Repository for a tenant
   * @request POST:/api/v1/tenants/{tenant}/git-repository
   * @secure
   */
  gitRepositoryCreate = (tenant: string, data: GitRepositoryCreate, params: RequestParams = {}) =>
    this.request<GitRepository, APIError>({
      path: `/api/v1/tenants/${tenant}/git-repository`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List available Git Repositories
   *
   * @name GitRepositoryListAvailable
   * @summary List available git repositories for a tenant
   * @request GET:/api/v1/tenants/{tenant}/git-repository/available
   * @secure
   */
  gitRepositoryListAvailable = (tenant: string, params: RequestParams = {}) =>
    this.request<GitRepositoryList, APIError>({
      path: `/api/v1/tenants/${tenant}/git-repository/available`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List branches for a git repository
   *
   * @name GitRepositoryListBranches
   * @summary List branches for a Git Repository
   * @request GET:/api/v1/tenants/{tenant}/git-repository/{provider}/{owner}/{name}/branches
   * @secure
   */
  gitRepositoryListBranches = (
    tenant: string,
    provider: GitRepositoryProvider,
    owner: string,
    name: string,
    params: RequestParams = {},
  ) =>
    this.request<GitRepositoryBranchList, APIError>({
      path: `/api/v1/tenants/${tenant}/git-repository/${provider}/${owner}/${name}/branches`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a git repository
   *
   * @name GitRepositoryGet
   * @summary Get Git Repository
   * @request GET:/api/v1/git-repository/{git-repository}
   * @secure
   */
  gitRepositoryGet = (gitRepository: string, params: RequestParams = {}) =>
    this.request<GitRepository, APIError>({
      path: `/api/v1/git-repository/${gitRepository}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a Git Repository for a tenant
   *
   * @name GitRepositoryUpdate
   * @summary Update Git Repository for a tenant
   * @request PATCH:/api/v1/git-repository/{git-repository}
   * @secure
   */
  gitRepositoryUpdate = (gitRepository: string, data: GitRepositoryUpdate, params: RequestParams = {}) =>
    this.request<GitRepository, APIError>({
      path: `/api/v1/git-repository/${gitRepository}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete git repository.
   *
   * @tags Git Repositories
   * @name GitRepositoryDelete
   * @summary Delete git repository.
   * @request DELETE:/api/v1/git-repository/{git-repository}
   * @secure
   */
  gitRepositoryDelete = (gitRepository: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/git-repository/${gitRepository}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Get code health overview for a git repository
   *
   * @name TenantGetCodeHealthOverview
   * @summary Get code health overview for a git repository
   * @request GET:/api/v1/tenants/{tenant}/code-health/overview
   * @secure
   */
  tenantGetCodeHealthOverview = (tenant: string, params: RequestParams = {}) =>
    this.request<CodeHealthOverview, APIError>({
      path: `/api/v1/tenants/${tenant}/code-health/overview`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Restore a soft-deleted git repository.
   *
   * @tags Git Repositories
   * @name GitRepositoryUpdateRestore
   * @summary Restore a git repository.
   * @request POST:/api/v1/git-repository/{git-repository}/restore
   * @secure
   */
  gitRepositoryUpdateRestore = (gitRepository: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/git-repository/${gitRepository}/restore`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Export SARIF scan data for a git repository
   *
   * @tags Git Repositories
   * @name GitRepositoryGetSarif
   * @summary Export SARIF scan data
   * @request GET:/api/v1/git-repository/{git-repository}/sarif
   * @secure
   */
  gitRepositoryGetSarif = (gitRepository: string, params: RequestParams = {}) =>
    this.request<string, APIError>({
      path: `/api/v1/git-repository/${gitRepository}/sarif`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Export SARIF scan data for multiple git repositories as a ZIP file
   *
   * @tags Git Repositories
   * @name GitRepositoryCreateSarifExport
   * @summary Bulk export SARIF scan data
   * @request POST:/api/v1/tenants/{tenant}/git-repository/bulk-sarif
   * @secure
   */
  gitRepositoryCreateSarifExport = (
    tenant: string,
    data: {
      /**
       * List of git repository IDs to export SARIF data from
       * @maxItems 100
       * @minItems 1
       */
      repositoryIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<File, APIError>({
      path: `/api/v1/tenants/${tenant}/git-repository/bulk-sarif`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description This endpoint ingests JSON data from the scan results of the code.
   *
   * @tags Code Health
   * @name GitRepositoryCreateScanResults
   * @summary Ingest Git Scan Data
   * @request POST:/api/internal/git-scan/results
   */
  gitRepositoryCreateScanResults = (data: ScanResultList, params: RequestParams = {}) =>
    this.request<void, void | APIError>({
      path: `/api/internal/git-scan/results`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Uploads code security scan results to GCS, and triggers ingestion into the main database for display on the platform. Not to be exposed to the public.
   *
   * @tags Code Security
   * @name GitRepositoryCreateCodeSecurityScanResults
   * @summary Upload results of a code security scan (internal endpoint)
   * @request POST:/api/internal/git-repositories/{git-repository}/code-security/scan-results
   */
  gitRepositoryCreateCodeSecurityScanResults = (
    gitRepository: string,
    data: CodeSecurityScanUploadRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, void | APIError>({
      path: `/api/internal/git-repositories/${gitRepository}/code-security/scan-results`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Marks a code security scan as failed by setting isScanning to false. Used when a scan workflow fails and needs to update the database state.
   *
   * @tags Code Security
   * @name GitRepositoryUpdateCodeSecurityScanFailed
   * @summary Mark a code security scan as failed (internal endpoint)
   * @request POST:/api/internal/git-repositories/{git-repository}/code-security/fail-scan
   */
  gitRepositoryUpdateCodeSecurityScanFailed = (
    gitRepository: string,
    data?: {
      /** Error message describing why the scan failed */
      errorMessage?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/internal/git-repositories/${gitRepository}/code-security/fail-scan`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description List tenant vendors
   *
   * @tags Vendor
   * @name TenantVendorList
   * @summary List tenant vendors
   * @request GET:/api/v1/tenants/{tenant}/vendors
   * @secure
   */
  tenantVendorList = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantVendorList, APIError>({
      path: `/api/v1/tenants/${tenant}/vendors`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create or update tenant vendors
   *
   * @tags Vendor
   * @name TenantVendorCreate
   * @summary Create or update tenant vendors
   * @request PUT:/api/v1/tenants/{tenant}/vendors
   * @secure
   */
  tenantVendorCreate = (tenant: string, data: CreateUpdateTenantVendor[], params: RequestParams = {}) =>
    this.request<TenantVendorList, APIError>({
      path: `/api/v1/tenants/${tenant}/vendors`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Lists discoveries which haven't been added as tenant vendors
   *
   * @tags Vendor
   * @name TenantVendorDiscoveryList
   * @summary List tenant vendor discoveries
   * @request GET:/api/v1/tenants/{tenant}/vendor-discoveries
   * @secure
   */
  tenantVendorDiscoveryList = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantVendorDiscoveryList, APIError>({
      path: `/api/v1/tenants/${tenant}/vendor-discoveries`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger a tenant scoped vendor discovery run
   *
   * @tags Vendor
   * @name TenantUpdateRunVendorDiscovery
   * @summary Create tenant vendor discovery
   * @request POST:/api/v1/tenants/{tenant}/vendor-discoveries
   * @secure
   */
  tenantUpdateRunVendorDiscovery = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantVendorDiscoveryWorkflowRun, APIError>({
      path: `/api/v1/tenants/${tenant}/vendor-discoveries`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete all vendor discoveries in a tenant
   *
   * @tags Vendor
   * @name TenantVendorDiscoveryDelete
   * @summary Delete tenant vendor discovery
   * @request DELETE:/api/v1/tenants/{tenant}/vendor-discoveries
   * @secure
   */
  tenantVendorDiscoveryDelete = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantVendorDiscoveryDeletedCount, APIError>({
      path: `/api/v1/tenants/${tenant}/vendor-discoveries`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List vendors
   *
   * @tags Vendor
   * @name VendorList
   * @summary List vendors
   * @request GET:/api/v1/vendors
   * @secure
   */
  vendorList = (params: RequestParams = {}) =>
    this.request<VendorList, APIError>({
      path: `/api/v1/vendors`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create or update vendors
   *
   * @tags Vendor
   * @name VendorCreateUpsert
   * @summary Create or update vendors
   * @request PUT:/api/v1/vendors
   * @secure
   */
  vendorCreateUpsert = (data: UpsertVendor[], params: RequestParams = {}) =>
    this.request<VendorList, APIError>({
      path: `/api/v1/vendors`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get vendor
   *
   * @tags Vendor
   * @name VendorGet
   * @summary Get vendor
   * @request GET:/api/v1/vendors/{vendor}
   * @secure
   */
  vendorGet = (vendor: string, params: RequestParams = {}) =>
    this.request<Vendor, APIError>({
      path: `/api/v1/vendors/${vendor}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete vendor
   *
   * @tags Vendor
   * @name VendorDelete
   * @summary Delete vendor
   * @request DELETE:/api/v1/vendors/{vendor}
   * @secure
   */
  vendorDelete = (vendor: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/vendors/${vendor}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Upload a logo for a vendor
   *
   * @name VendorUpdateLogo
   * @summary Upload a logo for a vendor
   * @request POST:/api/v1/vendors/{vendor}/logo
   * @secure
   */
  vendorUpdateLogo = (vendor: string, data: UploadVendorLogoRequest, params: RequestParams = {}) =>
    this.request<string, APIError>({
      path: `/api/v1/vendors/${vendor}/logo`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Get tenant vendor
   *
   * @tags Vendor
   * @name TenantVendorGet
   * @summary Get tenant vendor
   * @request GET:/api/v1/tenant-vendors/{tenant-vendor}
   * @secure
   */
  tenantVendorGet = (tenantVendor: string, params: RequestParams = {}) =>
    this.request<TenantVendor, APIError>({
      path: `/api/v1/tenant-vendors/${tenantVendor}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete tenant vendor
   *
   * @tags Vendor
   * @name TenantVendorDelete
   * @summary Delete tenant vendor
   * @request DELETE:/api/v1/tenant-vendors/{tenant-vendor}
   * @secure
   */
  tenantVendorDelete = (tenantVendor: string, params: RequestParams = {}) =>
    this.request<TenantVendor, APIError>({
      path: `/api/v1/tenant-vendors/${tenantVendor}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get external accounts for a tenant
   *
   * @tags ExternalAccount
   * @name ExternalAccountList
   * @summary Get external accounts by tenant
   * @request GET:/api/v1/tenants/{tenant}/external-accounts
   * @secure
   */
  externalAccountList = (tenant: string, params: RequestParams = {}) =>
    this.request<ExternalAccountList, APIError>({
      path: `/api/v1/tenants/${tenant}/external-accounts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an external account by its id
   *
   * @tags ExternalAccount
   * @name ExternalAccountUpdate
   * @summary Update external account
   * @request PATCH:/api/v1/external-accounts/{external-account}
   * @secure
   */
  externalAccountUpdate = (externalAccount: string, data: ExternalAccountUpdateRequest, params: RequestParams = {}) =>
    this.request<ExternalAccount, APIError>({
      path: `/api/v1/external-accounts/${externalAccount}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an external account by its id
   *
   * @tags ExternalAccount
   * @name ExternalAccountDelete
   * @summary Delete external account
   * @request DELETE:/api/v1/external-accounts/{external-account}
   * @secure
   */
  externalAccountDelete = (externalAccount: string, params: RequestParams = {}) =>
    this.request<ExternalAccount, APIError>({
      path: `/api/v1/external-accounts/${externalAccount}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all risk assessments associated with a tenant
   *
   * @name RiskAssessmentList
   * @summary List risk assessments
   * @request GET:/api/v1/tenants/{tenant}/risk-assessments
   * @secure
   */
  riskAssessmentList = (
    tenant: string,
    query?: {
      /** Whether to fetch completed or in progress risk assessments. True indicates only completed, false indicates on in progress, and both are returned by default. */
      completed?: boolean;
      /** The maximum number of records to fetch. Defaults to all. */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<RiskAssessment[], APIError>({
      path: `/api/v1/tenants/${tenant}/risk-assessments`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new risk assessment
   *
   * @name RiskAssessmentCreate
   * @summary Create a risk assessment
   * @request POST:/api/v1/tenants/{tenant}/risk-assessments
   * @secure
   */
  riskAssessmentCreate = (tenant: string, data: CreateRiskAssessmentRequest, params: RequestParams = {}) =>
    this.request<RiskAssessment, APIError>({
      path: `/api/v1/tenants/${tenant}/risk-assessments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a risk by id
   *
   * @name RiskGet
   * @summary Get risk
   * @request GET:/api/v1/risks/{risk}
   * @secure
   */
  riskGet = (risk: string, params: RequestParams = {}) =>
    this.request<Risk, APIError | void>({
      path: `/api/v1/risks/${risk}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a risk for a risk assessment
   *
   * @name RiskUpdate
   * @summary Update a risk
   * @request PATCH:/api/v1/risks/{risk}
   * @secure
   */
  riskUpdate = (risk: string, data: UpdateRiskRequest, params: RequestParams = {}) =>
    this.request<Risk, APIError>({
      path: `/api/v1/risks/${risk}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a risk from a risk assessment
   *
   * @name RiskDelete
   * @summary Delete a risk
   * @request DELETE:/api/v1/risks/{risk}
   * @secure
   */
  riskDelete = (risk: string, params: RequestParams = {}) =>
    this.request<Risk, APIError>({
      path: `/api/v1/risks/${risk}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Archive a risk, marking it as no longer relevant
   *
   * @name RiskUpdateArchive
   * @summary Archive a risk
   * @request POST:/api/v1/risks/{risk}/archive
   * @secure
   */
  riskUpdateArchive = (risk: string, params: RequestParams = {}) =>
    this.request<Risk, APIError>({
      path: `/api/v1/risks/${risk}/archive`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Unarchive a risk, marking it as relevant again
   *
   * @name RiskUpdateUnarchive
   * @summary Unarchive a risk
   * @request POST:/api/v1/risks/{risk}/unarchive
   * @secure
   */
  riskUpdateUnarchive = (risk: string, params: RequestParams = {}) =>
    this.request<Risk, APIError>({
      path: `/api/v1/risks/${risk}/unarchive`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a risk assessment by id
   *
   * @name RiskAssessmentGet
   * @summary Get risk assessment
   * @request GET:/api/v1/risks-assessments/{risk-assessment}
   * @secure
   */
  riskAssessmentGet = (riskAssessment: string, params: RequestParams = {}) =>
    this.request<RiskAssessment, APIError | void>({
      path: `/api/v1/risks-assessments/${riskAssessment}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a risk assessment
   *
   * @name RiskAssessmentUpdate
   * @summary Update a risk assessment
   * @request PATCH:/api/v1/risks-assessments/{risk-assessment}
   * @secure
   */
  riskAssessmentUpdate = (riskAssessment: string, data: UpdateRiskAssessmentRequest, params: RequestParams = {}) =>
    this.request<RiskAssessment, APIError>({
      path: `/api/v1/risks-assessments/${riskAssessment}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new risk for a risk assessment
   *
   * @name RiskCreate
   * @summary Create a risk
   * @request POST:/api/v1/risks-assessments/{risk-assessment}/risks
   * @secure
   */
  riskCreate = (riskAssessment: string, data: CreateRiskRequest, params: RequestParams = {}) =>
    this.request<Risk, APIError>({
      path: `/api/v1/risks-assessments/${riskAssessment}/risks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all the audit types for a tenant
   *
   * @name AuditTypeList
   * @summary List audit types
   * @request GET:/api/v1/tenants/{tenant}/audit-types
   * @secure
   */
  auditTypeList = (tenant: string, params: RequestParams = {}) =>
    this.request<AuditType[], void>({
      path: `/api/v1/tenants/${tenant}/audit-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all the audits for a tenant
   *
   * @name AuditList
   * @summary List audits
   * @request GET:/api/v1/tenants/{tenant}/audits
   * @secure
   */
  auditList = (tenant: string, params: RequestParams = {}) =>
    this.request<Audit[], void>({
      path: `/api/v1/tenants/${tenant}/audits`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new audit
   *
   * @name AuditCreate
   * @summary Create a audit
   * @request POST:/api/v1/tenants/{tenant}/audits
   * @secure
   */
  auditCreate = (tenant: string, data: CreateAuditPayload, params: RequestParams = {}) =>
    this.request<Audit, void>({
      path: `/api/v1/tenants/${tenant}/audits`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an audit
   *
   * @name AuditDelete
   * @summary Delete an audit
   * @request DELETE:/api/v1/audits/{audit}
   * @secure
   */
  auditDelete = (audit: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/v1/audits/${audit}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Update the stage of an audit
   *
   * @name AuditUpdateStage
   * @summary Update the stage of an audit
   * @request PATCH:/api/v1/audits/{audit}/stage
   * @secure
   */
  auditUpdateStage = (audit: string, data: UpdateAuditStagePayload, params: RequestParams = {}) =>
    this.request<Audit, void>({
      path: `/api/v1/audits/${audit}/stage`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete the report of an audit
   *
   * @name AuditDeleteReport
   * @summary Delete the report of an audit
   * @request DELETE:/api/v1/audits/{audit}/report
   * @secure
   */
  auditDeleteReport = (audit: string, params: RequestParams = {}) =>
    this.request<Audit, void>({
      path: `/api/v1/audits/${audit}/report`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the report of an audit
   *
   * @name AuditUpdateReport
   * @summary Update the report of an audit
   * @request PATCH:/api/v1/audits/{audit}/report
   * @secure
   */
  auditUpdateReport = (audit: string, data: UploadAuditReportPayload, params: RequestParams = {}) =>
    this.request<Audit, void>({
      path: `/api/v1/audits/${audit}/report`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Update the observation period of an audit
   *
   * @name AuditUpdateObservationPeriod
   * @summary Update the observation period of an audit
   * @request PATCH:/api/v1/audits/{audit}/observation-period
   * @secure
   */
  auditUpdateObservationPeriod = (
    audit: string,
    data: UpdateAuditObservationPeriodPayload,
    params: RequestParams = {},
  ) =>
    this.request<Audit, void>({
      path: `/api/v1/audits/${audit}/observation-period`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all audits with optional stage filtering
   *
   * @name AuditListAll
   * @summary List all audits with optional stage filtering
   * @request GET:/api/v1/audits
   * @secure
   */
  auditListAll = (
    query?: {
      /** The stages to filter by. */
      stages?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<Audit[], void>({
      path: `/api/v1/audits`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Revokes user's sessions as required by an Auth0 event
   *
   * @name Auth0ActionsDeleteSessions
   * @summary Revoke a user's sessions as required by an Auth0 event
   * @request POST:/api/v1/auth0-actions/revoke-sessions
   * @secure
   */
  auth0ActionsDeleteSessions = (data: Auth0RevokeSessionsRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/v1/auth0-actions/revoke-sessions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Get a users info by their email
   *
   * @name Auth0ActionsGetUser
   * @summary Get a users info by their email
   * @request GET:/api/v1/auth0-actions/user-info
   * @secure
   */
  auth0ActionsGetUser = (
    query: {
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Auth0UserInfoResponse, void>({
      path: `/api/v1/auth0-actions/user-info`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Export all old code health scanner data for a tenant.
   *
   * @tags code_health_scanner
   * @name TenantGetChsExport
   * @summary Export code health scanner data for a tenant
   * @request GET:/api/v1/tenants/{tenant}/code-health-export
   * @secure
   */
  tenantGetChsExport = (tenant: string, params: RequestParams = {}) =>
    this.request<File, APIError>({
      path: `/api/v1/tenants/${tenant}/code-health-export`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description List all code health issues for a tenant.
   *
   * @tags code_health_scanner
   * @name CodeHealthIssueList
   * @summary Get code health issues
   * @request GET:/api/v1/tenants/{tenant}/code-health-issues
   * @secure
   */
  codeHealthIssueList = (tenant: string, params: RequestParams = {}) =>
    this.request<CodeHealthIssue[], APIError>({
      path: `/api/v1/tenants/${tenant}/code-health-issues`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Bullk update a group of issues for a tenant based on ids
   *
   * @tags code_health_scanner
   * @name TenantUpdateCodeHealthIssue
   * @summary Bulk update code health issues
   * @request PATCH:/api/v1/tenants/{tenant}/code-health-issues
   * @secure
   */
  tenantUpdateCodeHealthIssue = (tenant: string, data: BulkUpdateCodeHealthIssueBody, params: RequestParams = {}) =>
    this.request<CodeHealthIssue[], APIError>({
      path: `/api/v1/tenants/${tenant}/code-health-issues`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update a code health issue.
   *
   * @tags code_health_scanner
   * @name CodeHealthIssueUpdate
   * @summary Update code health issue
   * @request PATCH:/api/v1/code-health-issues/{code-health-issue}
   * @secure
   */
  codeHealthIssueUpdate = (codeHealthIssue: string, data: UpdateCodeHealthIssueBody, params: RequestParams = {}) =>
    this.request<CodeHealthIssue, APIError>({
      path: `/api/v1/code-health-issues/${codeHealthIssue}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a list of all the repositories scan last run, next run and the status of the scan.
   *
   * @tags code_health_scanner
   * @name TenantGetChsScanInfo
   * @summary Get scan info
   * @request GET:/api/v1/tenants/{tenant}/chs-scan
   * @secure
   */
  tenantGetChsScanInfo = (
    tenant: string,
    query?: {
      /** List of repository ids */
      repositoryIds?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ScanInfoList, APIError>({
      path: `/api/v1/tenants/${tenant}/chs-scan`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger a re-scan for a git repository
   *
   * @name TenantUpdateChsTriggerScan
   * @summary Re-scan a git repository
   * @request PATCH:/api/v1/tenants/{tenant}/chs-scan
   * @secure
   */
  tenantUpdateChsTriggerScan = (
    tenant: string,
    query?: {
      /** List of repository ids */
      repositoryIds?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${tenant}/chs-scan`,
      method: "PATCH",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description List all issue types.
   *
   * @tags code_health_scanner
   * @name CodeHealthIssueTypeList
   * @summary Get issue types
   * @request GET:/api/v1/code-health-issue-types
   * @secure
   */
  codeHealthIssueTypeList = (params: RequestParams = {}) =>
    this.request<CodeHealthIssueType[], APIError>({
      path: `/api/v1/code-health-issue-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an issue type.
   *
   * @tags code_health_scanner
   * @name CodeHealthIssueTypeUpdate
   * @summary Update issue type
   * @request PATCH:/api/v1/code-health-issue-types/{code-health-issue-type}
   * @secure
   */
  codeHealthIssueTypeUpdate = (
    codeHealthIssueType: string,
    data: UpdateCodeHealthIssueTypeBody,
    params: RequestParams = {},
  ) =>
    this.request<CodeHealthIssueType, APIError>({
      path: `/api/v1/code-health-issue-types/${codeHealthIssueType}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all ignore rules for a tenant.
   *
   * @tags code_health_scanner
   * @name CodeHealthIgnoreRuleList
   * @summary Get ignore rules
   * @request GET:/api/v1/tenants/{tenant}/code-health-ignore-rule
   * @secure
   */
  codeHealthIgnoreRuleList = (tenant: string, params: RequestParams = {}) =>
    this.request<CodeHealthIgnoreRule[], APIError>({
      path: `/api/v1/tenants/${tenant}/code-health-ignore-rule`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new rule to ignore issue types.
   *
   * @tags code_health_scanner
   * @name CodeHealthIgnoreRuleCreate
   * @summary Create ignore rule
   * @request POST:/api/v1/tenants/{tenant}/code-health-ignore-rule
   * @secure
   */
  codeHealthIgnoreRuleCreate = (tenant: string, data: CreateCodeHealthIgnoreRuleBody, params: RequestParams = {}) =>
    this.request<CodeHealthIgnoreRule, APIError>({
      path: `/api/v1/tenants/${tenant}/code-health-ignore-rule`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update an ignore rule.
   *
   * @tags code_health_scanner
   * @name CodeHealthIgnoreRuleUpdate
   * @summary Update ignore rule
   * @request PATCH:/api/v1/code-health-ignore-rules/{code-health-ignore-rule}
   * @secure
   */
  codeHealthIgnoreRuleUpdate = (
    codeHealthIgnoreRule: string,
    data: UpdateCodeHealthIgnoreRuleBody,
    params: RequestParams = {},
  ) =>
    this.request<CodeHealthIgnoreRule, APIError>({
      path: `/api/v1/code-health-ignore-rules/${codeHealthIgnoreRule}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an ignore rule.
   *
   * @tags code_health_scanner
   * @name CodeHealthIgnoreRuleDelete
   * @summary Delete ignore rule
   * @request DELETE:/api/v1/code-health-ignore-rules/{code-health-ignore-rule}
   * @secure
   */
  codeHealthIgnoreRuleDelete = (codeHealthIgnoreRule: string, params: RequestParams = {}) =>
    this.request<CodeHealthIgnoreRule, APIError>({
      path: `/api/v1/code-health-ignore-rules/${codeHealthIgnoreRule}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the code health scanner settings for a tenant.
   *
   * @tags Tenant
   * @name TenantGetCodeSecuritySettings
   * @summary Get the code health scanner settings for a tenant.
   * @request GET:/api/v1/tenants/{tenant}/code-security-settings
   * @secure
   */
  tenantGetCodeSecuritySettings = (tenant: string, params: RequestParams = {}) =>
    this.request<CodeSecuritySettings, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates the code health scanner settings for a tenant.
   *
   * @tags code_security_scanner
   * @name TenantUpdateCodeSecuritySettings
   * @summary Updates the code health scanner settings for a tenant.
   * @request PUT:/api/v1/tenants/{tenant}/code-security-settings
   * @secure
   */
  tenantUpdateCodeSecuritySettings = (
    tenant: string,
    data: UpdateCodeSecuritySettingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<CodeSecuritySettings, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all code security findings for a tenant.
   *
   * @tags code_security_scanner
   * @name CodeSecurityFindingList
   * @summary Get code security findings for a tenant
   * @request GET:/api/v1/tenants/{tenant}/code-security-findings
   * @secure
   */
  codeSecurityFindingList = (tenant: string, params: RequestParams = {}) =>
    this.request<CodeSecurityFindingList, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-findings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a single code security finding.
   *
   * @tags code_security_scanner
   * @name CodeSecurityFindingUpdate
   * @summary Update a code security finding
   * @request PATCH:/api/v1/tenants/{tenant}/code-security-findings/{code-security-finding}
   * @secure
   */
  codeSecurityFindingUpdate = (
    tenant: string,
    codeSecurityFinding: string,
    data: UpdateCodeSecurityFindingBody,
    params: RequestParams = {},
  ) =>
    this.request<CodeSecurityFindingList, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-findings/${codeSecurityFinding}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a list of all the repositories scan last run, next run and the status of the scan.
   *
   * @tags code_security_scanner
   * @name TenantGetCodeSecurityScanInfo
   * @summary Get scan info for a tenant
   * @request GET:/api/v1/tenants/{tenant}/code-security-scan
   * @secure
   */
  tenantGetCodeSecurityScanInfo = (
    tenant: string,
    query?: {
      /** List of repository ids */
      repositoryIds?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<CodeSecurityScanInfoList, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-scan`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all code security ignore rules for a tenant.
   *
   * @tags code_security_scanner
   * @name CodeSecurityIgnoreRuleList
   * @summary Get code security ignore rules for a tenant
   * @request GET:/api/v1/tenants/{tenant}/code-security-ignore-rules
   * @secure
   */
  codeSecurityIgnoreRuleList = (tenant: string, params: RequestParams = {}) =>
    this.request<CodeSecurityIgnoreRuleList, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-ignore-rules`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new ignore rule for a specific issue in a repository.
   *
   * @tags code_security_scanner
   * @name CodeSecurityIgnoreRuleCreate
   * @summary Create a new code security ignore rule
   * @request POST:/api/v1/tenants/{tenant}/code-security-ignore-rules
   * @secure
   */
  codeSecurityIgnoreRuleCreate = (tenant: string, data: CreateCodeSecurityIgnoreRuleBody, params: RequestParams = {}) =>
    this.request<CodeSecurityIgnoreRule, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-ignore-rules`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Gets a specific ignore rule by ID.
   *
   * @tags code_security_scanner
   * @name CodeSecurityIgnoreRuleGet
   * @summary Get a specific code security ignore rule
   * @request GET:/api/v1/tenants/{tenant}/code-security-ignore-rules/{code-security-ignore-rule}
   * @secure
   */
  codeSecurityIgnoreRuleGet = (tenant: string, codeSecurityIgnoreRule: string, params: RequestParams = {}) =>
    this.request<CodeSecurityIgnoreRule, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-ignore-rules/${codeSecurityIgnoreRule}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing ignore rule.
   *
   * @tags code_security_scanner
   * @name CodeSecurityIgnoreRuleUpdate
   * @summary Update a code security ignore rule
   * @request PATCH:/api/v1/tenants/{tenant}/code-security-ignore-rules/{code-security-ignore-rule}
   * @secure
   */
  codeSecurityIgnoreRuleUpdate = (
    tenant: string,
    codeSecurityIgnoreRule: string,
    data: UpdateCodeSecurityIgnoreRuleBody,
    params: RequestParams = {},
  ) =>
    this.request<CodeSecurityIgnoreRule, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-ignore-rules/${codeSecurityIgnoreRule}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes an existing ignore rule.
   *
   * @tags code_security_scanner
   * @name CodeSecurityIgnoreRuleDelete
   * @summary Delete a code security ignore rule
   * @request DELETE:/api/v1/tenants/{tenant}/code-security-ignore-rules/{code-security-ignore-rule}
   * @secure
   */
  codeSecurityIgnoreRuleDelete = (tenant: string, codeSecurityIgnoreRule: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenants/${tenant}/code-security-ignore-rules/${codeSecurityIgnoreRule}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List all the attack surface assets for a tenant
   *
   * @tags attack-surface
   * @name AttackSurfaceAssetList
   * @summary List all the attack surface assets for a tenant
   * @request GET:/api/v1/tenants/{tenant}/attack-surface-assets
   * @secure
   */
  attackSurfaceAssetList = (tenant: string, params: RequestParams = {}) =>
    this.request<AttackSurfaceAsset[], APIError>({
      path: `/api/v1/tenants/${tenant}/attack-surface-assets`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all the attack surface targets for a tenant
   *
   * @tags attack-surface
   * @name AttackSurfaceTargetList
   * @summary List all the attack surface targets for a tenant
   * @request GET:/api/v1/tenants/{tenant}/attack-surface-targets
   * @secure
   */
  attackSurfaceTargetList = (tenant: string, params: RequestParams = {}) =>
    this.request<AttackSurfaceTarget[], APIError>({
      path: `/api/v1/tenants/${tenant}/attack-surface-targets`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a domain as a target for a tenant
   *
   * @tags attack-surface
   * @name AttackSurfaceTargetCreate
   * @summary Add a domain as a target for a tenant
   * @request POST:/api/v1/tenants/{tenant}/attack-surface-targets
   * @secure
   */
  attackSurfaceTargetCreate = (
    tenant: string,
    data: {
      domains: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<AttackSurfaceTarget[], APIError>({
      path: `/api/v1/tenants/${tenant}/attack-surface-targets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update an attack surface asset
   *
   * @tags attack-surface
   * @name AttackSurfaceAssetUpdate
   * @summary Update an attack surface asset
   * @request PATCH:/api/v1/attack-surface-assets/{attack-surface-asset}
   * @secure
   */
  attackSurfaceAssetUpdate = (
    attackSurfaceAsset: string,
    data: UpdateAttackSurfaceAssetRequest,
    params: RequestParams = {},
  ) =>
    this.request<AttackSurfaceAsset, APIError>({
      path: `/api/v1/attack-surface-assets/${attackSurfaceAsset}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a domain as a target for a tenant
   *
   * @tags attack-surface
   * @name AttackSurfaceTargetDelete
   * @summary Remove a domain as a target for a tenant
   * @request DELETE:/api/v1/attack-surface-targets/{attack-surface-target}
   * @secure
   */
  attackSurfaceTargetDelete = (attackSurfaceTarget: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/attack-surface-targets/${attackSurfaceTarget}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Get scans
   *
   * @tags attack-surface
   * @name TenantGetAttackSurfaceScanInfo
   * @summary Get scans
   * @request GET:/api/v1/tenant/{tenant}/attack-surface-scans
   * @secure
   */
  tenantGetAttackSurfaceScanInfo = (tenant: string, params: RequestParams = {}) =>
    this.request<AttackSurfaceScanInfo[], APIError>({
      path: `/api/v1/tenant/${tenant}/attack-surface-scans`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger a scan
   *
   * @tags attack-surface
   * @name TenantUpdateAttackSurfaceTriggerScan
   * @summary Trigger a scan
   * @request PATCH:/api/v1/tenant/{tenant}/attack-surface-scans
   * @secure
   */
  tenantUpdateAttackSurfaceTriggerScan = (
    tenant: string,
    data: {
      domains: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<void, APIError>({
      path: `/api/v1/tenant/${tenant}/attack-surface-scans`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Get the Apple MDM configuration for a tenant
   *
   * @name TenantGetAppleMdm
   * @summary Get the Apple MDM settings for a tenant
   * @request GET:/api/v1/tenants/{tenant}/apple-mdm
   * @secure
   */
  tenantGetAppleMdm = (tenant: string, params: RequestParams = {}) =>
    this.request<AppleMDMSettings, APIError>({
      path: `/api/v1/tenants/${tenant}/apple-mdm`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generate a new CSR for a tenant
   *
   * @name AppleMdmCreateCsr
   * @summary Generate a new CSR for a tenant
   * @request POST:/api/v1/tenants/{tenant}/apple-mdm/generate-csr
   * @secure
   */
  appleMdmCreateCsr = (tenant: string, data: AppleMDMGenCSRRequest, params: RequestParams = {}) =>
    this.request<File, APIError>({
      path: `/api/v1/tenants/${tenant}/apple-mdm/generate-csr`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Upload the signed MDM push certificate issued by Apple
   *
   * @name AppleMdmCreatePushCert
   * @summary Upload the signed MDM push certificate issued by Apple
   * @request POST:/api/v1/tenants/{tenant}/apple-mdm/upload-push-cert
   * @secure
   */
  appleMdmCreatePushCert = (
    tenant: string,
    data: {
      /** @format binary */
      path?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, APIError>({
      path: `/api/v1/tenants/${tenant}/apple-mdm/upload-push-cert`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Download the MDM enrollment profile for a tenant
   *
   * @name TenantGetMdmEnrollmentProfile
   * @summary Download the MDM enrollment profile for a tenant
   * @request GET:/api/v1/tenants/{tenant}/apple-mdm/download-enrollment-profile
   * @secure
   */
  tenantGetMdmEnrollmentProfile = (tenant: string, params: RequestParams = {}) =>
    this.request<File, APIError>({
      path: `/api/v1/tenants/${tenant}/apple-mdm/download-enrollment-profile`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Upsert a device as reported by the Apple MDM
   *
   * @name AppleMdmCreateUpsertDevice
   * @summary Upsert a device as reported by the Apple MDM
   * @request POST:/api/internal/apple-mdm/upsertDevice
   */
  appleMdmCreateUpsertDevice = (data: UpsertAppleMDMDeviceRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/internal/apple-mdm/upsertDevice`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Notify the server that a device has been unenrolled from Apple MDM
   *
   * @name AppleMdmDeleteDevice
   * @summary Notify the server that a device has been unenrolled from Apple MDM
   * @request POST:/api/internal/apple-mdm/deviceUnenrolled
   */
  appleMdmDeleteDevice = (data: UnenrollAppleMDMDeviceRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/internal/apple-mdm/deviceUnenrolled`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Get the current user's security training progress.
   *
   * @tags Security Training
   * @name SecurityTrainingModuleList
   * @request GET:/api/v1/tenants/{tenant}/security-training-modules
   * @secure
   */
  securityTrainingModuleList = (tenant: string, params: RequestParams = {}) =>
    this.request<SecurityTrainingModule[], any>({
      path: `/api/v1/tenants/${tenant}/security-training-modules`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the current user's security training progress.
   *
   * @tags Security Training
   * @name SecurityTrainingModuleListUserProgress
   * @request GET:/api/v1/tenants/{tenant}/security-training-modules/user-progress
   * @secure
   */
  securityTrainingModuleListUserProgress = (tenant: string, params: RequestParams = {}) =>
    this.request<UserSecurityTrainingProgress[], any>({
      path: `/api/v1/tenants/${tenant}/security-training-modules/user-progress`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the current user's security training progress.
   *
   * @tags Security Training
   * @name SecurityTrainingModuleListMyProgress
   * @request GET:/api/v1/tenants/{tenant}/security-training-modules/my-progress
   * @secure
   */
  securityTrainingModuleListMyProgress = (tenant: string, params: RequestParams = {}) =>
    this.request<MyProgressSecurityTrainingModule[], any>({
      path: `/api/v1/tenants/${tenant}/security-training-modules/my-progress`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the current user's security training progress.
   *
   * @tags Security Training
   * @name SecurityTrainingModuleGet
   * @request GET:/api/v1/security-training-modules/{security-training-module}
   * @secure
   */
  securityTrainingModuleGet = (securityTrainingModule: string, params: RequestParams = {}) =>
    this.request<SecurityTrainingModule, any>({
      path: `/api/v1/security-training-modules/${securityTrainingModule}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the content of a specific security training section.
   *
   * @tags Security Training
   * @name SecurityTrainingModuleUpdate
   * @request PATCH:/api/v1/security-training-modules/{security-training-module}
   * @secure
   */
  securityTrainingModuleUpdate = (
    securityTrainingModule: string,
    data: UpdateSecurityTrainingModuleRequestBody,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/v1/security-training-modules/${securityTrainingModule}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Update the progress for a specific section for the current user.
   *
   * @tags Security Training
   * @name SecurityTrainingModuleUpdateMyProgress
   * @request PATCH:/api/v1/security-training-modules/{security-training-module}/user-progress
   * @secure
   */
  securityTrainingModuleUpdateMyProgress = (
    securityTrainingModule: string,
    data: MyProgressUpdateSectionProgressRequestBody,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/v1/security-training-modules/${securityTrainingModule}/user-progress`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description List devices for a tenant
   *
   * @tags Device Management
   * @name TenantDeviceList
   * @summary List devices
   * @request GET:/api/v1/tenants/{tenant}/tenant-devices
   * @secure
   */
  tenantDeviceList = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantDeviceList, APIError>({
      path: `/api/v1/tenants/${tenant}/tenant-devices`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List devices for the current user
   *
   * @name TenantDeviceListMe
   * @request GET:/api/v1/tenants/{tenant}/tenant-devices/me
   * @secure
   */
  tenantDeviceListMe = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantDeviceList, any>({
      path: `/api/v1/tenants/${tenant}/tenant-devices/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a device
   *
   * @tags Device Management
   * @name TenantDeviceGet
   * @summary Get device
   * @request GET:/api/v1/tenant-devices/{tenant-device}
   * @secure
   */
  tenantDeviceGet = (tenantDevice: string, params: RequestParams = {}) =>
    this.request<TenantDevice, APIError>({
      path: `/api/v1/tenant-devices/${tenantDevice}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a tenant device
   *
   * @tags Device Management
   * @name TenantDeviceUpdate
   * @summary Update device
   * @request PATCH:/api/v1/tenant-devices/{tenant-device}
   * @secure
   */
  tenantDeviceUpdate = (tenantDevice: string, data: UpdateTenantDeviceRequest, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/tenant-devices/${tenantDevice}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Get tenant h-module meta.json
   *
   * @tags HModule
   * @name TenantGetHModulesMeta
   * @summary Get tenant h-module meta.json
   * @request GET:/api/v1/tenants/{tenant}/h-modules
   * @secure
   */
  tenantGetHModulesMeta = (tenant: string, params: RequestParams = {}) =>
    this.request<TenantHModuleMeta, APIError>({
      path: `/api/v1/tenants/${tenant}/h-modules`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get h-module landing page, it could be the only html shown by the module or an html containing a list of items
   *
   * @tags HModule
   * @name TenantGetHModuleLanding
   * @summary Get h-module landing page
   * @request GET:/api/v1/tenants/{tenant}/h-modules/{hmodule}
   * @secure
   */
  tenantGetHModuleLanding = (tenant: string, hmodule: string, params: RequestParams = {}) =>
    this.request<HModuleLanding, APIError>({
      path: `/api/v1/tenants/${tenant}/h-modules/${hmodule}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger an h-module action
   *
   * @name TenantUpdateHModuleAction
   * @summary Trigger an h-module action
   * @request PATCH:/api/v1/tenants/{tenant}/h-modules/{hmodule}
   * @secure
   */
  tenantUpdateHModuleAction = (
    tenant: string,
    hmodule: string,
    data: {
      /** The action to trigger */
      action?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<MonitorUpdateConfig, APIError>({
      path: `/api/v1/tenants/${tenant}/h-modules/${hmodule}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get h-module item HTML
   *
   * @tags HModule
   * @name TenantGetHModuleItem
   * @summary Get h-module item HTML
   * @request GET:/api/v1/tenants/{tenant}/h-modules/{hmodule}/{hmodule-item}
   * @secure
   */
  tenantGetHModuleItem = (tenant: string, hmodule: string, hmoduleItem: string, params: RequestParams = {}) =>
    this.request<string, APIError>({
      path: `/api/v1/tenants/${tenant}/h-modules/${hmodule}/${hmoduleItem}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireList
   * @summary List questionnaires for tenant
   * @request GET:/api/v1/tenants/{tenant}/questionnaires
   * @secure
   */
  questionnaireList = (tenant: string, params: RequestParams = {}) =>
    this.request<QuestionnaireList, APIError>({
      path: `/api/v1/tenants/${tenant}/questionnaires`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireCreate
   * @summary Upload new questionnaire for tenant
   * @request POST:/api/v1/tenants/{tenant}/questionnaires
   * @secure
   */
  questionnaireCreate = (tenant: string, data: UploadNewQuestionnaireBody, params: RequestParams = {}) =>
    this.request<QuestionnaireDetail, APIError>({
      path: `/api/v1/tenants/${tenant}/questionnaires`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireGet
   * @summary Get questionnaire details
   * @request GET:/api/v1/questionnaire/{questionnaire}
   * @secure
   */
  questionnaireGet = (questionnaire: string, params: RequestParams = {}) =>
    this.request<QuestionnaireDetail, APIError>({
      path: `/api/v1/questionnaire/${questionnaire}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireUpdate
   * @summary Update questionnaire
   * @request PATCH:/api/v1/questionnaire/{questionnaire}
   * @secure
   */
  questionnaireUpdate = (questionnaire: string, data: UpdateQuestionnaireBody, params: RequestParams = {}) =>
    this.request<QuestionnaireDetail, APIError>({
      path: `/api/v1/questionnaire/${questionnaire}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireGetDownload
   * @summary Download questionnaire file
   * @request GET:/api/v1/questionnaire/{questionnaire}/download
   * @secure
   */
  questionnaireGetDownload = (questionnaire: string, params: RequestParams = {}) =>
    this.request<void, APIError>({
      path: `/api/v1/questionnaire/${questionnaire}/download`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireUpdateOwner
   * @summary Update questionnaire owner
   * @request PATCH:/api/v1/questionnaire/{questionnaire}/owner
   * @secure
   */
  questionnaireUpdateOwner = (questionnaire: string, data: UpdateQuestionnaireOwnerBody, params: RequestParams = {}) =>
    this.request<QuestionnaireDetail, APIError>({
      path: `/api/v1/questionnaire/${questionnaire}/owner`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireUpdateAnswer
   * @summary Edit answer for a question
   * @request PATCH:/api/v1/questionnaire/{questionnaire}/answer/{question}
   * @secure
   */
  questionnaireUpdateAnswer = (
    questionnaire: string,
    question: string,
    data: UpdateQuestionnaireQuestionAnswerBody,
    params: RequestParams = {},
  ) =>
    this.request<QuestionnaireQuestion, APIError>({
      path: `/api/v1/questionnaire/${questionnaire}/answer/${question}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireUpdateAcceptAnswer
   * @summary Accept answer for a question
   * @request PATCH:/api/v1/questionnaire/{questionnaire}/answer/{question}/accept
   * @secure
   */
  questionnaireUpdateAcceptAnswer = (questionnaire: string, question: string, params: RequestParams = {}) =>
    this.request<QuestionnaireQuestion, APIError>({
      path: `/api/v1/questionnaire/${questionnaire}/answer/${question}/accept`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Questionnaire Center
   * @name QuestionnaireUpdateComplete
   * @summary Complete questionnaire
   * @request PATCH:/api/v1/questionnaire/{questionnaire}/complete
   * @secure
   */
  questionnaireUpdateComplete = (questionnaire: string, params: RequestParams = {}) =>
    this.request<QuestionnaireDetail, APIError>({
      path: `/api/v1/questionnaire/${questionnaire}/complete`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an exposed account (resolution status, resolution actions)
   *
   * @tags Exposed Account
   * @name ExposedAccountUpdate
   * @summary Update exposed account
   * @request PUT:/api/v1/exposed-accounts/{exposed-account}
   * @secure
   */
  exposedAccountUpdate = (exposedAccount: string, data: ExposedAccountUpdateRequest, params: RequestParams = {}) =>
    this.request<ExposedAccount, APIError>({
      path: `/api/v1/exposed-accounts/${exposedAccount}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
